
import * as verilogGrammar from "../../../src/Renderer/VerilogComponent/VerilogGrammar.js";
import nearley from "nearley";
import { parseFromFile, fix } from "../../../src/Renderer/VerilogComponent/parser.js";
import { menu, list as list_9, Item_Option, Item_li } from "../fable_modules/Fulma.3.0.0/Components/Menu.fs.js";
import { SVGAttr, CSSProp, Prop, HTMLAttr, DOMAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { length as length_1, item as item_2, findIndexBack, indexed, partition, mapIndexed2, concat as concat_1, find, contains as contains_1, choose, sort, tryPick, head, tail, sortBy, last, exists as exists_1, fold, empty as empty_1, tryFind, append, isEmpty as isEmpty_1, map, cons, filter, singleton, ofArray } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { split, toFail, printf, toText, concat } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { uncurry2, Exception, uncurry3, stringHash, comparePrimitives, compare, defaultOf, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { menuLabelStyle, getHeaderHeight } from "./Style.js";
import { SheetInfo, Memory1, InitMemData, NumberBase, HighLightColor, shifterWidthFor, ShiftComponentType, Project, Component, LoadedComponent, CCForm, ComponentType, CustomComponentType, BoundingBox, XYPos } from "../Common/CommonTypes.js";
import { getSymbolColour, createNewSymbol } from "../DrawBlock/Symbol.js";
import { reduceApprox, openSheetArrayInfo, isArrayOnlyComponent, openSheetIsReadOnly, tryGetLoadedComponents } from "./ModelHelpers.js";
import { Optic_Set, Optic_Set_op_HatEquals_Z147477F8, Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89 } from "../Common/Optics.js";
import { DrawModelType_SheetT_Msg, DrawModelType_SymbolT_Annotation, DrawModelType_SymbolT_Symbol, DrawModelType_SymbolT_appearance_, DrawModelType_SymbolT_colour_ } from "../Model/DrawModelType.js";
import { value as value_4, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { find as find_1, toList as toList_1, tryFind as tryFind_1, empty, isEmpty, exists } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { MouseOp, MouseT, boxesIntersect } from "../Common/DrawHelpers.js";
import { FileCommandType, openLibrary_, catalogueSearch_, UICommandType, PopupDialogData, Model, DragGhost, Msg } from "../Model/ModelType.js";
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.13.0/FSharp.Core.js";
import { signatureOfInstance } from "../Simulator/CanvasExtractor.js";
import { addParamComponent, joinsOnChannel, paramInputField, addParamComponents, customComponentParamPopup, getDefaultParamDefs, paramBindingsOfModel } from "./ParameterView.js";
import { ComponentLibrary, libraryIsEditable, openLibrary, readComponentAndDependencies, isLibraryProject, tryReadComponentShape, sheetNameFor, libraryIndexFor } from "../Interface/ComponentLibraries.js";
import { contains, ofList } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { Result_IsError, Result_Map, FSharpResult$2, Result_Bind } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { JsonHelpers_stateToJsonString, ResultList_sequence, RegenerateIds_regenerateSheetIds, ResultList_fold } from "../Common/Helpers.js";
import { tryReadFileSync, initialiseMem, tryLoadComponentFromPath, writeFile, pathJoin } from "../Interface/FilesIO.js";
import { openFileInProject, saveOpenFileActionWithModelUpdate, formatLabelFromType, writeComponentToFile } from "./MenuHelpers.js";
import { errorFilesNotification } from "./Notifications.js";
import { getTextEventValue, debugLevel } from "../Interface/JSHelpers.js";
import { Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { ParamBoxState, renderParamExpression, ParamConstraint, CompSlotName, intOfParamInt, NewParamCompSpec, ParamExpression, paramBoxKey, ParamConstraint_$reflection, ParamExpression_$reflection, CompSlotName_$reflection } from "../Common/ParameterTypes.js";
import { record_type, list_type, option_type, bigint_type, string_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { compare as compare_1, toString, equals as equals_1, op_LeftShift, op_Subtraction, op_BitwiseAnd, fromZero, fromOne, fromInt32 } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { constraintsFor } from "../Common/ComponentSlots.js";
import { choicePopup, verilogEditorTemplate, getCode, dialogVerilogCompBody, dialogVerilogPopup, getMemorySetup, dialogPopupBodyMemorySetup, dialogPopupBodyNInts, getIntList2, getIntList, dialogPopupBodyOnlyBoundedInt, getInt, dialogPopupBodyOnlyInt, dialogPopupBodyOnlyTextWithDefaultValue, getText, dialogPopupBodyOnlyText, dialogPopup } from "../DrawBlock/PopupHelpers.js";
import * as react_1 from "react";
import { StringModule_StartsWithLetter } from "../Common/EEExtensions.js";
import { empty as empty_2, singleton as singleton_1, append as append_1, delay, toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { List_groupBy, List_distinct } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { Option, tag as tag_10, List_Option, list as list_8 } from "../fable_modules/Fulma.3.0.0/Elements/Tag.fs.js";
import { Common_GenericOption, Size_ISize, Color_IColor } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { input as input_12 } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option as Option_1, IInputType } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { strToIntCheckWidth, Constants_maxNumericCharsBeforeTruncation, BigIntToPaddedString, Constants_maxIssieBusWidth } from "../Simulator/NumberHelpers.js";
import { Option as Option_2, div } from "../fable_modules/Fulma.3.0.0/Elements/Form/Field.fs.js";
import { div as div_1 } from "../fable_modules/Fulma.3.0.0/Elements/Form/Control.fs.js";
import { Option as Option_3, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { getSyntaxErrorInfo, getErrorDiv } from "../VerilogComponent/CodeEditorHelpers.js";
import { SimpleJson_tryParse } from "../Common/SimpleJson/SimpleJson.js";
import { Convert_fromJson } from "../Common/SimpleJson/Json.Converter.js";
import { createTypeInfo } from "../Common/SimpleJson/TypeInfo.Converter.js";
import { CodeEditorOpen, VerilogInput_$reflection, ParserOutput_$reflection } from "../VerilogComponent/VerilogTypes.js";
import { getSemanticErrors } from "../VerilogComponent/ErrorCheck.js";
import { tryLast } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { createSheet } from "../VerilogComponent/SheetCreator.js";
import { updateVerilogFileActionWithModelUpdate } from "./TopMenuView.js";
import { dataTooltip } from "../fable_modules/Fulma.Extensions.Wikiki.Tooltip.4.0.0/Tooltip.fs.js";
import { drawComponent } from "../DrawBlock/SymbolView.js";
import { newArrayComponentPopup } from "./ArraySheetView.js";




export const Constants_maxGateInputs = 19;

export const Constants_maxSplitMergeBranches = 19;

export const Constants_ghostBoxW = 100;

export const Constants_ghostBoxH = 60;

export const Constants_ghostErrorColour = "Red";

export function menuItem(styles, label, onClick) {
    return Item_li(ofArray([new Item_Option(/* IsActive */ 0, [false]), new Item_Option(/* Props */ 1, [ofArray([new DOMAttr(/* OnClick */ 40, [onClick]), ["style", keyValueList(styles, 1)]])])]), singleton(label));
}

/**
 * As menuItem, carrying an id so that a right-click on the row can be told from a right-click on
 * anything else. The id is what UpdateHelpers.getContextMenu matches on - it is handed the element
 * under the pointer and nothing else, so a row that wants a context menu has to say what it is.
 */
export function menuItemWithId(elementId, styles, label, onClick) {
    return Item_li(ofArray([new Item_Option(/* IsActive */ 0, [false]), new Item_Option(/* Props */ 1, [ofArray([new HTMLAttr(/* Id */ 99, [elementId]), new DOMAttr(/* OnClick */ 40, [onClick]), ["style", keyValueList(styles, 1)]])])]), singleton(label));
}

/**
 * The id a library's row in the catalogue carries. The name follows the prefix verbatim rather
 * than being separated out later: a library is a directory, and a directory name may contain
 * whatever the platform allows.
 */
export function libraryRowId(libraryName) {
    return concat("CatalogueLibrary:", libraryName);
}

function sheetPosOfCursor(cursor, sheet) {
    const matchValue = document.getElementById("Canvas");
    if (equals(matchValue, defaultOf())) {
        return undefined;
    }
    else {
        const canvas = matchValue;
        const box = canvas.getBoundingClientRect();
        const matchValue_1 = (((cursor.X >= box.left) && (cursor.X <= box.right)) && (cursor.Y >= box.top)) && (cursor.Y <= box.bottom);
        if (matchValue_1) {
            return new XYPos((cursor.X + canvas.scrollLeft) / sheet.Zoom, ((cursor.Y - getHeaderHeight()) + canvas.scrollTop) / sheet.Zoom);
        }
        else {
            return undefined;
        }
    }
}

function ghostSymbol(model, compType, clocked, pos) {
    let optic, value;
    const theme = model.Sheet.Wire.Symbol.Theme;
    const sym = createNewSymbol(tryGetLoadedComponents(model), pos, compType, "", theme);
    if (clocked) {
        return ((optic = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_colour_)(DrawModelType_SymbolT_appearance_), (value = getSymbolColour(compType, true, theme), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, optic)(value))))(new DrawModelType_SymbolT_Symbol(sym.Pos, sym.CentrePos, sym.OffsetFromBBCentre, sym.InWidth0, sym.InWidth1, sym.InWidths, sym.LabelBoundingBox, sym.LabelHasDefaultPos, sym.LabelRotation, sym.Appearance, sym.Id, sym.Component, sym.Annotation, sym.Moving, true, sym.STransform, sym.ReversedInputPorts, sym.PortMaps, sym.HScale, sym.VScale, sym.MovingPort, sym.MovingPortTarget, sym.ArrayText));
    }
    else {
        return sym;
    }
}

function ghostBoundingBox(model, ghost, sheetPos) {
    let left, right;
    if (ghost.tag === 1) {
        return new BoundingBox(new XYPos(sheetPos.X - (Constants_ghostBoxW / 2), sheetPos.Y - (Constants_ghostBoxH / 2)), Constants_ghostBoxW, Constants_ghostBoxH);
    }
    else {
        const sym_1 = ghostSymbol(model, ghost.fields[0], ghost.fields[1], sheetPos);
        let patternInput;
        const sym_2 = sym_1;
        const comp = sym_2.Component;
        const matchValue = defaultArg(sym_2.HScale, 1);
        const vS = defaultArg(sym_2.VScale, 1);
        const hS = matchValue;
        const matchValue_2 = sym_2.STransform.Rotation;
        switch (matchValue_2.tag) {
            case 1:
            case 3: {
                patternInput = [comp.W * hS, comp.H * vS];
                break;
            }
            default:
                patternInput = [comp.H * vS, comp.W * hS];
        }
        if (equals(sym_1.Annotation, DrawModelType_SymbolT_Annotation.ScaleButton)) {
            return new BoundingBox((left = sym_1.Pos, (right = (new XYPos(9, 9)), new XYPos(left.X - right.X, left.Y - right.Y))), 17, 17);
        }
        else {
            return new BoundingBox(sym_1.Pos, patternInput[1], patternInput[0]);
        }
    }
}

function ghostOverlaps(model, ghost, cursor) {
    const matchValue = sheetPosOfCursor(cursor, model.Sheet);
    if (matchValue != null) {
        const box = ghostBoundingBox(model, ghost, matchValue);
        return exists((_arg, symbolBox) => boxesIntersect(symbolBox, box), model.Sheet.BoundingBoxes);
    }
    else {
        return false;
    }
}

function placementItem(styles, ghostOf, label, place, model, dispatch) {
    const carryingThis = (ev) => (ev.currentTarget.__issieCarrying === true);
    const setCarrying = (ev_1, carrying) => {
        ev_1.currentTarget.__issieCarrying = carrying;
    };
    return Item_li(ofArray([new Item_Option(/* IsActive */ 0, [false]), new Item_Option(/* Props */ 1, [ofArray([["style", keyValueList(styles, 1)], new DOMAttr(/* OnPointerDown */ 69, [(ev_4) => {
        setCarrying(ev_4, true);
        const ghost_1 = ghostOf();
        ev_4.currentTarget.__issieGhost = ghost_1;
        try {
            ev_4.currentTarget.setPointerCapture(ev_4.pointerId);
        }
        catch (matchValue) {
        }
        dispatch(new Msg(/* StartDragPlacement */ 89, [ghost_1, new XYPos(ev_4.clientX, ev_4.clientY)]));
    }]), new DOMAttr(/* OnPointerMove */ 70, [(ev_5) => {
        if (carryingThis(ev_5)) {
            dispatch(new Msg(/* MoveDragPlacement */ 90, [new XYPos(ev_5.clientX, ev_5.clientY)]));
        }
    }]), new DOMAttr(/* OnPointerUp */ 71, [(ev_6) => {
        if (carryingThis(ev_6)) {
            setCarrying(ev_6, false);
            const cursor = new XYPos(ev_6.clientX, ev_6.clientY);
            let matchValue_1;
            let option_1;
            const carried = ev_6.currentTarget.__issieGhost;
            option_1 = (Operators_IsNull(carried) ? undefined : carried);
            matchValue_1 = ((option_1 != null) ? ghostOverlaps(model, option_1, cursor) : undefined);
            let matchResult;
            if (matchValue_1 == null) {
                matchResult = 1;
            }
            else if (matchValue_1) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    dispatch(Msg.EndDragPlacement);
                    break;
                }
                case 1: {
                    const matchValue_2 = sheetPosOfCursor(cursor, model.Sheet);
                    if (matchValue_2 == null) {
                        dispatch(Msg.EndDragPlacement);
                    }
                    else {
                        dispatch(new Msg(/* DropDragPlacement */ 91, [matchValue_2]));
                    }
                    place();
                    break;
                }
            }
        }
    }]), new DOMAttr(/* OnPointerCancel */ 72, [(ev_7) => {
        if (carryingThis(ev_7)) {
            setCarrying(ev_7, false);
            dispatch(Msg.EndDragPlacement);
        }
    }])])])]), singleton(label));
}

function startPlacement(placeMsg, model, dispatch) {
    if (openSheetIsReadOnly(model)) {
        dispatch(Msg.EndDragPlacement);
    }
    else {
        dispatch(new Msg(/* Sheet */ 3, [placeMsg]));
        const matchValue = model.DragPlacement;
        let matchResult, pos;
        if (matchValue != null) {
            if (matchValue.tag === 1) {
                matchResult = 0;
                pos = matchValue.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const atDropPoint = (op) => (new MouseT(pos, new XYPos(0, 0), new XYPos(0, 0), false, op));
                dispatch(Msg.EndDragPlacement);
                dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* MouseMsg */ 7, [atDropPoint(MouseOp.Move)])]));
                dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* MouseMsg */ 7, [atDropPoint(MouseOp.Down)])]));
                break;
            }
            case 1: {
                break;
            }
        }
    }
}

function createComponent(compType, label, createParam, model, dispatch) {
    if (isArrayOnlyComponent(compType) && (openSheetArrayInfo(model) == null)) {
        dispatch(Msg.EndDragPlacement);
    }
    else {
        startPlacement(new DrawModelType_SheetT_Msg(/* InitialiseCreateComponent */ 20, [tryGetLoadedComponents(model), compType, label, createParam]), model, dispatch);
    }
}

export function createCompStdLabel(comp, createParam, model, dispatch) {
    createComponent(comp, "", createParam, model, dispatch);
}

function placeCustomComponent(loadedComponent, bindings, createParam, model, dispatch) {
    const patternInput = defaultArg(signatureOfInstance(cons(loadedComponent, filter((l) => (l.Name !== loadedComponent.Name), tryGetLoadedComponents(model))), paramBindingsOfModel(model), loadedComponent.Name, bindings), [loadedComponent.InputLabels, loadedComponent.OutputLabels]);
    const custom = new ComponentType(/* Custom */ 26, [new CustomComponentType(loadedComponent.Name, patternInput[0], patternInput[1], loadedComponent.Form, isEmpty(bindings) ? undefined : bindings, loadedComponent.Description)]);
    startPlacement(new DrawModelType_SheetT_Msg(/* InitialiseCreateComponent */ 20, [tryGetLoadedComponents(model), custom, "", createParam]), model, dispatch);
}

/**
 * Start placing an instance of a sheet. A sheet that declares parameters asks for a value for
 * each of them first: placing without asking would silently freeze the sheet's defaults into the
 * instance, which is exactly the stale-chain problem.
 */
export function startPlacingCustomComponent(loadedComponent, model, dispatch) {
    if (isEmpty(getDefaultParamDefs(loadedComponent))) {
        placeCustomComponent(loadedComponent, empty({
            Compare: (x, y) => (compare(x, y) | 0),
        }), undefined, model, dispatch);
    }
    else {
        customComponentParamPopup(loadedComponent, (bindings, specs) => {
            placeCustomComponent(loadedComponent, bindings, (compId) => {
                addParamComponents(specs, dispatch, compId);
            }, model, dispatch);
        }, model, dispatch);
    }
}

function customGhost(loadedComponent) {
    return new DragGhost(/* GhostSymbol */ 0, [new ComponentType(/* Custom */ 26, [new CustomComponentType(loadedComponent.Name, loadedComponent.InputLabels, loadedComponent.OutputLabels, loadedComponent.Form, undefined, loadedComponent.Description)]), false]);
}

function placeSheetOnGesture(loadedComponent, dispatch, unitVar) {
    dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model$0027, dispatch$0027) => {
        startPlacingCustomComponent(loadedComponent, model$0027, dispatch$0027);
    }, dispatch]));
}

function makeCustom(styles, model, dispatch, loadedComponent) {
    return placementItem(styles, () => customGhost(loadedComponent), loadedComponent.Name, () => {
        placeSheetOnGesture(loadedComponent, dispatch, undefined);
    }, model, dispatch);
}

function materialiseLibraryComponent(libName, files, project) {
    const index = libraryIndexFor(project.LoadedComponents, libName) | 0;
    const inLibrary = ofList(map((tupledArg) => tupledArg[0].Name, files), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    return Result_Bind((ldcs) => {
        if (isEmpty_1(ldcs)) {
            return new FSharpResult$2(/* Error */ 1, [concat("Library ", libName, " has no component to place")]);
        }
        else {
            return new FSharpResult$2(/* Ok */ 0, [ldcs]);
        }
    }, ResultList_fold((got, file) => {
        let existing, _arg_1, header_1, sheetName, matchValue_1, destPath, matchValue_2, matchValue_3, ldc_3, ldc, bind$0040, patternInput;
        return Result_Map((ldc_4) => append(got, singleton(ldc_4)), (existing = append(project.LoadedComponents, got), (_arg_1 = file, (header_1 = _arg_1[0], (sheetName = sheetNameFor(index, header_1.Name), (matchValue_1 = tryFind((ldc_1) => (ldc_1.Name === sheetName), existing), (matchValue_1 == null) ? ((destPath = pathJoin([project.ProjectPath, sheetName + ".dgm"]), (matchValue_2 = writeFile(destPath, _arg_1[1]), (matchValue_2.tag === 0) ? ((matchValue_3 = tryLoadComponentFromPath(destPath), (matchValue_3.tag === 0) ? ((ldc_3 = ((ldc = ((bind$0040 = RegenerateIds_regenerateSheetIds(matchValue_3.fields[0]), new LoadedComponent(sheetName, bind$0040.TimeStamp, bind$0040.FilePath, bind$0040.WaveInfo, bind$0040.CanvasState, bind$0040.InputLabels, bind$0040.OutputLabels, bind$0040.LCParameterSlots, new CCForm(/* Library */ 1, [libName, header_1.Name]), bind$0040.LoadedComponentIsOutOfDate, bind$0040.Description, bind$0040.IsTopSheet, bind$0040.ArrayInfo))), (patternInput = ldc.CanvasState, new LoadedComponent(ldc.Name, ldc.TimeStamp, ldc.FilePath, ldc.WaveInfo, [map((comp) => {
            const matchValue = comp.Type;
            let matchResult, cc_1;
            if (matchValue.tag === 26) {
                if (contains(matchValue.fields[0].Name, inLibrary)) {
                    matchResult = 0;
                    cc_1 = matchValue.fields[0];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return new Component(comp.Id, new ComponentType(/* Custom */ 26, [new CustomComponentType(sheetNameFor(index, cc_1.Name), cc_1.InputLabels, cc_1.OutputLabels, cc_1.Form, cc_1.ParameterBindings, cc_1.Description)]), comp.Label, comp.InputPorts, comp.OutputPorts, comp.X, comp.Y, comp.H, comp.W, comp.SymbolInfo, comp.SlotInfo);
                default:
                    return comp;
            }
        }, patternInput[0]), patternInput[1]], ldc.InputLabels, ldc.OutputLabels, ldc.LCParameterSlots, ldc.Form, ldc.LoadedComponentIsOutOfDate, ldc.Description, ldc.IsTopSheet, ldc.ArrayInfo)))), (void writeComponentToFile(ldc_3), new FSharpResult$2(/* Ok */ 0, [ldc_3])))) : (new FSharpResult$2(/* Error */ 1, [`Could not add ${header_1.Name} from library ${libName}: ${matchValue_3.fields[0]}`])))) : (new FSharpResult$2(/* Error */ 1, [concat("Could not write ", sheetName, ": ", matchValue_2.fields[0])]))))) : (new FSharpResult$2(/* Ok */ 0, [matchValue_1]))))))));
    }, empty_1(), files));
}

function libraryGhost(library, listing, model) {
    const matchValue = model.CurrentProj;
    const matchValue_1 = tryReadComponentShape(library.Path, listing.Header.Name);
    let matchResult, project, shape;
    if (matchValue != null) {
        const copyOfStruct = matchValue_1;
        if (copyOfStruct.tag === 0) {
            matchResult = 0;
            project = matchValue;
            shape = copyOfStruct.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new DragGhost(/* GhostSymbol */ 0, [new ComponentType(/* Custom */ 26, [new CustomComponentType(sheetNameFor(libraryIndexFor(project.LoadedComponents, library.Name), listing.Header.Name), shape.InputLabels, shape.OutputLabels, new CCForm(/* Library */ 1, [library.Name, listing.Header.Name]), undefined, listing.Header.Description)]), shape.IsClocked]);
        default:
            return new DragGhost(/* GhostBox */ 1, [listing.Header.Name]);
    }
}

function startPlacingLibraryComponent(library, listing, model, dispatch) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        if (isLibraryProject(matchValue)) {
            const project_1 = matchValue;
            dispatch(new Msg(/* SetFilesNotification */ 79, [errorFilesNotification(concat(listing.Header.Name, " cannot be placed in a library. Sheets of this library are offered under \'This project\'."))]));
        }
        else {
            const project_2 = matchValue;
            const placed = Result_Bind((files) => materialiseLibraryComponent(library.Name, files, project_2), readComponentAndDependencies(library.Path, listing.Header.Name));
            if (placed.tag === 0) {
                if (isEmpty_1(placed.fields[0])) {
                }
                else {
                    const ldcs = placed.fields[0];
                    dispatch(new Msg(/* UpdateModel */ 41, [(m) => {
                        const matchValue_1 = m.CurrentProj;
                        if (matchValue_1 != null) {
                            const p = matchValue_1;
                            return new Model(m.WindowWidth, m.KeyFocusPane, m.RunAfterRenderWithSpinner, m.UserData, m.WaveSim, m.WaveSimSheet, m.UISheetTrail, m.Spinner, m.Sheet, m.IsLoading, m.LastChangeCheckTime, m.LastSimulatedCanvasState, m.LastDetailedSavedState, m.CurrentSelected, m.LastSelectedIds, m.LastUsedDialogWidth, m.SelectedComponent, m.CurrentStepSimulationStep, m.CurrentTruthTable, m.TTConfig, m.RightPaneTabVisible, m.SimSubTabVisible, m.CircuitCheck, m.Hilighted, m.Clipboard, m.LastCreatedComponent, m.SavedSheetIsOutOfDate, m.PendingDragAddition, m.DragPlacement, m.ProjectBrowser, m.TopSheetChoiceDeclined, m.ComponentLibraries, m.OpenLibrary, m.CatalogueSearch, m.ArrayCopiesTyped, m.SimulateInRenderer, m.SidecarSession, m.ProbeRead, m.SidecarInFlight, m.SidecarBuildEndedMs, m.SidecarRunEndedMs, m.StepRunTarget, m.FetchedData, m.FetchedStructure, m.FailedFetch, m.StimulusGeneration, m.CurrentViewport, m.ViewportChangedAtMs, m.WaveScrollSettling, m.WaveScrollSerial, m.ShowLibrarySheets, m.SuppressErrorPopups, m.OpenedLibrarySheets, m.ReadOnlyBaseline, new Project(p.ProjectPath, p.OpenFileName, p.WorkingFileName, fold((known, ldc) => {
                                if (exists_1((c) => (c.Name === ldc.Name), known)) {
                                    return known;
                                }
                                else {
                                    return append(known, singleton(ldc));
                                }
                            }, p.LoadedComponents, ldcs)), m.PopupViewFunc, m.SpinnerPayload, m.PopupDialogData, m.Notifications, m.TopMenuOpenState, m.SheetMenuPinned, m.DividerDragMode, m.WaveSimViewerWidth, m.ConnsOfSelectedWavesAreHighlighted, m.Pending, m.UIState, m.BuildVisible, m.CodeEditorState);
                        }
                        else {
                            return m;
                        }
                    }]));
                    const toPlace = last(ldcs);
                    dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model$0027, dispatch$0027) => {
                        startPlacingCustomComponent(toPlace, model$0027, dispatch$0027);
                    }, dispatch]));
                }
            }
            else {
                dispatch(new Msg(/* SetFilesNotification */ 79, [errorFilesNotification(placed.fields[0])]));
            }
        }
    }
}

function makeCustomList(keep, styles, model, dispatch) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        return map((loadedComponent) => makeCustom(styles, model, dispatch, loadedComponent), sortBy((x) => x.Name, filter((comp_2) => keep(comp_2.Name, defaultArg(comp_2.Description, "")), filter((comp_1) => {
            if (debugLevel() !== 0) {
                if (equals(comp_1.Form, CCForm.User) ? true : equals(comp_1.Form, CCForm.ProtectedTopLevel)) {
                    return true;
                }
                else {
                    return equals(comp_1.Form, CCForm.ProtectedSubSheet);
                }
            }
            else if (equals(comp_1.Form, CCForm.User)) {
                return true;
            }
            else {
                return equals(comp_1.Form, CCForm.ProtectedTopLevel);
            }
        }, filter((comp) => (comp.Name !== project.OpenFileName), project.LoadedComponents))), {
            Compare: (x_1, y) => (comparePrimitives(x_1, y) | 0),
        }));
    }
    else {
        return empty_1();
    }
}

function makeVerilog(styles, model, dispatch, loadedComponent) {
    return placementItem(styles, () => customGhost(loadedComponent), loadedComponent.Name, () => {
        placeSheetOnGesture(loadedComponent, dispatch, undefined);
    }, model, dispatch);
}

function makeVerilogList(keep, styles, model, dispatch) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        return map((loadedComponent) => makeVerilog(styles, model, dispatch, loadedComponent), filter((comp_2) => keep(comp_2.Name, defaultArg(comp_2.Description, "")), filter((comp_1) => {
            const matchValue_1 = comp_1.Form;
            let matchResult;
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 4) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return true;
                default:
                    return false;
            }
        }, filter((comp) => (comp.Name !== project.OpenFileName), project.LoadedComponents))));
    }
    else {
        return empty_1();
    }
}

class CreationParam extends Record {
    constructor(Slot, Prompt, Default, DefaultExpr, Constraints) {
        super();
        this.Slot = Slot;
        this.Prompt = Prompt;
        this.Default = Default;
        this.DefaultExpr = DefaultExpr;
        this.Constraints = Constraints;
    }
}

function CreationParam_$reflection() {
    return record_type("CatalogueView.CreationParam", [], CreationParam, () => [["Slot", CompSlotName_$reflection()], ["Prompt", string_type], ["Default", bigint_type], ["DefaultExpr", option_type(ParamExpression_$reflection())], ["Constraints", list_type(ParamConstraint_$reflection())]]);
}

function slotParam(proto, slot, prompt, defaultValue) {
    return new CreationParam(slot, prompt, fromInt32(defaultValue), undefined, constraintsFor(slot, proto));
}

function slotParamExpr(proto, slot, prompt, expr, value) {
    const bind$0040 = slotParam(proto, slot, prompt, value);
    return new CreationParam(bind$0040.Slot, bind$0040.Prompt, bind$0040.Default, expr, bind$0040.Constraints);
}

function paramBoxValues(dialog, boxes) {
    return ResultList_sequence(map((box) => {
        let _arg;
        let binder;
        const key = paramBoxKey(undefined, box.Slot);
        binder = ((table) => tryFind_1(key, table));
        const option_1 = dialog.DialogState;
        _arg = ((option_1 != null) ? binder(option_1) : undefined);
        if (_arg == null) {
            return new FSharpResult$2(/* Ok */ 0, [new NewParamCompSpec(box.Slot, defaultArg(box.DefaultExpr, new ParamExpression(/* PInt */ 0, [box.Default])), box.Constraints, box.Default)]);
        }
        else {
            return _arg.Spec;
        }
    }, boxes));
}

function paramBox(dispatch, box, model$0027) {
    let matchValue;
    return paramInputField(model$0027, box.Prompt, box.Default, (matchValue = paramBoxValues(model$0027.PopupDialogData, singleton(box)), (matchValue.tag === 0) ? (!isEmpty_1(matchValue.fields[0]) ? (isEmpty_1(tail(matchValue.fields[0])) ? head(matchValue.fields[0]).Value : undefined) : undefined) : undefined), box.DefaultExpr, box.Constraints, undefined, undefined, box.Slot, dispatch);
}

function paramBoxInts(specs) {
    return map((spec) => (intOfParamInt(1, spec.Value) | 0), specs);
}

function paramSlotsOf(dispatch, specs) {
    return (compId) => {
        addParamComponents(specs, dispatch, compId);
    };
}

function createInputPopup(typeStr, compType, model, dispatch) {
    const title = toText(printf("Add %s node"))(typeStr);
    const width = slotParam(compType([1, undefined]), CompSlotName.Buswidth, toText(printf("How many bits should the %s node have?"))(typeStr), model.LastUsedDialogWidth);
    let defaultValue;
    const bind$0040 = slotParam(compType([1, undefined]), CompSlotName.InputDefault, "If the input is undriven, what should the default value be?", 0);
    defaultValue = (new CreationParam(bind$0040.Slot, bind$0040.Prompt, bind$0040.Default, bind$0040.DefaultExpr, empty_1()));
    const boxes = ofArray([width, defaultValue]);
    dialogPopup(title, (model$0027) => {
        const children = [dialogPopupBodyOnlyText((_arg) => toText(printf("How do you want to name your %s?"))(typeStr), "Component name", dispatch, model$0027), paramBox(dispatch, width, model$0027), paramBox(dispatch, defaultValue, model$0027)];
        return react_1.createElement("div", {}, ...children);
    }, "Add", (model$0027_1) => {
        const matchValue = paramBoxValues(model$0027_1.PopupDialogData, boxes);
        if (matchValue.tag === 0) {
            const specs = matchValue.fields[0];
            const inputText = getText(model$0027_1.PopupDialogData);
            const comp = compType([intOfParamInt(1, head(specs).Value), head(tail(specs)).Value]);
            createComponent(comp, formatLabelFromType(comp, inputText), paramSlotsOf(dispatch, specs), model, dispatch);
            dispatch(Msg.ClosePopup);
        }
    }, (model$0027_2) => {
        let s_2;
        if ((s_2 = getText(model$0027_2.PopupDialogData), (s_2 === "") ? true : !StringModule_StartsWithLetter(s_2))) {
            return true;
        }
        else {
            return Result_IsError(paramBoxValues(model$0027_2.PopupDialogData, boxes));
        }
    }, empty_1(), dispatch);
}

function createJoinPopup(typeStr, compType, model, dispatch) {
    let info;
    const title = toText(printf("Add %s node"))(typeStr);
    const width = slotParam(compType([1, 0]), new CompSlotName(/* IO */ 1, [""]), toText(printf("How many bits should the %s carry?"))(typeStr), 1);
    let channelDefault;
    const option_1 = openSheetArrayInfo(model);
    channelDefault = ((option_1 != null) ? ((info = option_1, (compType([1, 0]).tag === 52) ? [new ParamExpression(/* PAdd */ 2, [new ParamExpression(/* PParameter */ 1, [info.LoopParam]), new ParamExpression(/* PInt */ 0, [fromOne()])]), 1] : [new ParamExpression(/* PParameter */ 1, [info.LoopParam]), 0])) : undefined);
    let channel;
    if (channelDefault == null) {
        channel = slotParam(compType([1, 0]), CompSlotName.JoinNum, "Which channel? Usually an expression in this sheet\'s loop variable, such as i or i+1.", 0);
    }
    else {
        const value = channelDefault[1] | 0;
        const expr = channelDefault[0];
        channel = slotParamExpr(compType([1, 0]), CompSlotName.JoinNum, "Which channel? Usually an expression in this sheet\'s loop variable, such as i or i+1.", expr, value);
    }
    const boxes = ofArray([width, channel]);
    const existingWidth = (model$0027) => tryPick((comp) => {
        const matchValue_1 = comp.Type;
        let matchResult, w;
        switch (matchValue_1.tag) {
            case 52: {
                matchResult = 0;
                w = matchValue_1.fields[0];
                break;
            }
            case 53: {
                matchResult = 0;
                w = matchValue_1.fields[0];
                break;
            }
            default:
                matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return w;
            default:
                return undefined;
        }
    }, joinsOnChannel(model$0027, getText(model$0027.PopupDialogData)));
    dialogPopup(title, (model$0027_1) => {
        const children_2 = toList(delay(() => append_1(singleton_1(dialogPopupBodyOnlyText((_arg) => toText(printf("What channel name should this %s use?"))(typeStr), "Channel name", dispatch, model$0027_1)), delay(() => {
            let matchValue_2, w_1, props;
            return append_1((matchValue_2 = existingWidth(model$0027_1), (matchValue_2 == null) ? singleton_1(paramBox(dispatch, width, model$0027_1)) : ((w_1 = (matchValue_2 | 0), singleton_1((props = [["style", {
                fontSize: "0.85em",
                color: "grey",
            }]], react_1.createElement("p", keyValueList(props, 1), `This channel already carries ${w_1} bits, so this will too.`)))))), delay(() => singleton_1(paramBox(dispatch, channel, model$0027_1))));
        }))));
        return react_1.createElement("div", {}, ...children_2);
    }, "Add", (model$0027_2) => {
        const matchValue_3 = paramBoxValues(model$0027_2.PopupDialogData, boxes);
        if (matchValue_3.tag === 0) {
            const specs = matchValue_3.fields[0];
            const inputText = getText(model$0027_2.PopupDialogData);
            let comp_1;
            const matchValue_4 = paramBoxInts(specs);
            const matchValue_5 = existingWidth(model$0027_2);
            let matchResult_1, numInt, w_2, numInt_1, widthInt;
            if (!isEmpty_1(matchValue_4)) {
                if (!isEmpty_1(tail(matchValue_4))) {
                    if (isEmpty_1(tail(tail(matchValue_4)))) {
                        if (matchValue_5 == null) {
                            matchResult_1 = 1;
                            numInt_1 = head(tail(matchValue_4));
                            widthInt = head(matchValue_4);
                        }
                        else {
                            matchResult_1 = 0;
                            numInt = head(tail(matchValue_4));
                            w_2 = matchValue_5;
                        }
                    }
                    else {
                        matchResult_1 = 2;
                    }
                }
                else {
                    matchResult_1 = 2;
                }
            }
            else {
                matchResult_1 = 2;
            }
            switch (matchResult_1) {
                case 0: {
                    comp_1 = compType([w_2, numInt]);
                    break;
                }
                case 1: {
                    comp_1 = compType([widthInt, numInt_1]);
                    break;
                }
                default:
                    comp_1 = toFail(printf("createJoinPopup: two boxes must give two numbers"));
            }
            createComponent(comp_1, formatLabelFromType(comp_1, inputText), paramSlotsOf(dispatch, specs), model, dispatch);
            dispatch(Msg.ClosePopup);
        }
    }, (model$0027_3) => {
        let s_3;
        if ((s_3 = getText(model$0027_3.PopupDialogData), (s_3 === "") ? true : !StringModule_StartsWithLetter(s_3))) {
            return true;
        }
        else {
            return Result_IsError(paramBoxValues(model$0027_3.PopupDialogData, boxes));
        }
    }, empty_1(), dispatch);
}

function createIOPopup(hasInt, typeStr, compType, model, dispatch) {
    const title = toText(printf("Add %s node"))(typeStr);
    const width = slotParam(compType(1), CompSlotName.Buswidth, toText(printf("How many bits should the %s node have?"))(typeStr), model.LastUsedDialogWidth);
    const textBody = (model_1) => dialogPopupBodyOnlyText((_arg) => toText(printf("How do you want to name your %s?"))(typeStr), "Component name", dispatch, model_1);
    const body = hasInt ? ((model$0027) => {
        const children = [textBody(model$0027), paramBox(dispatch, width, model$0027)];
        return react_1.createElement("div", {}, ...children);
    }) : textBody;
    if (hasInt) {
        dialogPopup(title, body, "Add", (model$0027_2) => {
            const inputText = getText(model$0027_2.PopupDialogData);
            const place = (widthInt, createParam) => {
                createComponent(compType(widthInt), formatLabelFromType(compType(widthInt), inputText), createParam, model, dispatch);
                dispatch(Msg.ClosePopup);
            };
            if (hasInt) {
                const matchValue = paramBoxValues(model$0027_2.PopupDialogData, singleton(width));
                if (matchValue.tag === 0) {
                    const specs = matchValue.fields[0];
                    place(head(paramBoxInts(specs)), paramSlotsOf(dispatch, specs));
                }
            }
            else {
                place(1, undefined);
            }
        }, (model$0027_3) => {
            let s_2;
            if ((s_2 = getText(model$0027_3.PopupDialogData), (s_2 === "") ? true : !StringModule_StartsWithLetter(s_2))) {
                return true;
            }
            else if (hasInt) {
                return Result_IsError(paramBoxValues(model$0027_3.PopupDialogData, singleton(width)));
            }
            else {
                return false;
            }
        }, empty_1(), dispatch);
    }
}

function netLabelNames(model) {
    return sort(List_distinct(choose((tupledArg) => {
        const sym = tupledArg[1];
        if (sym.Component.Type.tag === 3) {
            return sym.Component.Label;
        }
        else {
            return undefined;
        }
    }, toList_1(model.Sheet.Wire.Symbol.Symbols)), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    });
}

function typedNetName(model) {
    return formatLabelFromType(ComponentType.IOLabel, getText(model.PopupDialogData));
}

function newNetProblem(model) {
    const matchValue = getText(model.PopupDialogData);
    if (matchValue === "") {
        return undefined;
    }
    else if (!StringModule_StartsWithLetter(matchValue)) {
        return "Name must start with a letter";
    }
    else {
        const name = typedNetName(model);
        if (contains_1(name, netLabelNames(model), {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        })) {
            return concat(name, " is already a net on this sheet - join it above instead");
        }
        else {
            return undefined;
        }
    }
}

function createNetLabelPopup(model, dispatch) {
    const placeNetLabel = (name) => {
        createComponent(ComponentType.IOLabel, formatLabelFromType(ComponentType.IOLabel, name), undefined, model, dispatch);
        dispatch(Msg.ClosePopup);
    };
    dialogPopup("Add net label", (model$0027) => {
        const nets = netLabelNames(model$0027);
        const problem = newNetProblem(model$0027);
        const children_6 = toList(delay(() => {
            let matchValue, props, children;
            return append_1((matchValue = nets, isEmpty_1(matchValue) ? singleton_1(defaultOf()) : singleton_1((props = [["style", {
                marginBottom: "10px",
            }]], (children = ["Join a net on this sheet:", list_8(singleton(new List_Option(/* Props */ 6, [singleton(["style", {
                marginTop: "6px",
            }])])), map((name_1) => tag_10(ofArray([new Option(/* Color */ 1, [Color_IColor.IsInfo]), new Option(/* Props */ 4, [ofArray([new Prop(/* Key */ 0, [name_1]), ["style", {
                cursor: "pointer",
            }], new DOMAttr(/* OnClick */ 40, [(_arg) => {
                placeNetLabel(name_1);
            }])])])]), singleton(name_1)), matchValue))], react_1.createElement("div", keyValueList(props, 1), ...children))))), delay(() => append_1(singleton_1(isEmpty_1(nets) ? "Name the net:" : "Or name a new net:"), delay(() => append_1(singleton_1(input_12(ofArray([new Option_1(/* Type */ 1, [IInputType.Text$]), new Option_1(/* Props */ 15, [ofArray([new HTMLAttr(/* AutoFocus */ 55, [true]), new HTMLAttr(/* SpellCheck */ 148, [false])])]), new Option_1(/* Placeholder */ 12, ["Net name"]), new Option_1(/* OnChange */ 13, [(arg_2) => {
                dispatch(new Msg(/* SetPopupDialogText */ 52, [getTextEventValue(arg_2)]));
            }])]))), delay(() => {
                let matchValue_1, message, props_2;
                return append_1((matchValue_1 = problem, (matchValue_1 != null) ? ((message = matchValue_1, singleton_1((props_2 = [["style", {
                    fontStyle: "Italic",
                    color: "Red",
                }]], react_1.createElement("span", keyValueList(props_2, 1), message))))) : singleton_1(defaultOf())), delay(() => {
                    let props_4;
                    return append_1(singleton_1((props_4 = [["style", {
                        marginTop: "12px",
                        marginBottom: "8px",
                    }]], react_1.createElement("hr", keyValueList(props_4, 1)))), delay(() => {
                        let props_12, children_4, s_5, s_6;
                        return singleton_1((props_12 = [["style", {
                            fontSize: "0.9em",
                        }]], (children_4 = ["In a digital schematic a set of connected wires is called a net.", react_1.createElement("br", {}), (s_5 = "Every net label with the same name is one net, so a signal can be picked up anywhere on the sheet with no wire drawn to it.", s_5), react_1.createElement("br", {}), (s_6 = "Use net labels instead of a wire that would cross the sheet, and for high fan-out: drive the net once, then join it at each input it feeds.", s_6), react_1.createElement("br", {}), "Exactly one label in a net may be driven; the rest drive inputs."], react_1.createElement("div", keyValueList(props_12, 1), ...children_4))));
                    }));
                }));
            }))))));
        }));
        return react_1.createElement("div", {}, ...children_6);
    }, "Add", (model$0027_1) => {
        placeNetLabel(getText(model$0027_1.PopupDialogData));
    }, (model$0027_2) => {
        if (getText(model$0027_2.PopupDialogData) === "") {
            return true;
        }
        else {
            return newNetProblem(model$0027_2) != null;
        }
    }, empty_1(), dispatch);
}

export function createSheetDescriptionPopup(model, previousDescr, sheetName, dispatch) {
    dialogPopup(toText(printf("Sheet Description")), (model_1) => dialogPopupBodyOnlyTextWithDefaultValue((_arg) => toText(printf("Add description for sheet \'%s\'"))(sheetName), "Description", previousDescr, dispatch, model_1), "Save", (model$0027) => {
        const descr = getText(model$0027.PopupDialogData);
        const descrToSave = (descr === "") ? undefined : descr;
        const matchValue = model.CurrentProj;
        if (matchValue != null) {
            const p = matchValue;
            const target_ldc = find((x) => (x.Name === sheetName), p.LoadedComponents);
            const target_ldc$0027 = new LoadedComponent(target_ldc.Name, target_ldc.TimeStamp, target_ldc.FilePath, target_ldc.WaveInfo, target_ldc.CanvasState, target_ldc.InputLabels, target_ldc.OutputLabels, target_ldc.LCParameterSlots, target_ldc.Form, target_ldc.LoadedComponentIsOutOfDate, descrToSave, target_ldc.IsTopSheet, target_ldc.ArrayInfo);
            const p$0027 = new Project(p.ProjectPath, p.OpenFileName, p.WorkingFileName, append(map((ldc) => (new LoadedComponent(ldc.Name, ldc.TimeStamp, ldc.FilePath, ldc.WaveInfo, [map((comp) => {
                const matchValue_1 = comp.Type;
                let matchResult, x_3;
                if (matchValue_1.tag === 26) {
                    if (matchValue_1.fields[0].Name === sheetName) {
                        matchResult = 0;
                        x_3 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return new Component(comp.Id, new ComponentType(/* Custom */ 26, [new CustomComponentType(x_3.Name, x_3.InputLabels, x_3.OutputLabels, x_3.Form, x_3.ParameterBindings, descrToSave)]), comp.Label, comp.InputPorts, comp.OutputPorts, comp.X, comp.Y, comp.H, comp.W, comp.SymbolInfo, comp.SlotInfo);
                    default:
                        return comp;
                }
            }, ldc.CanvasState[0]), ldc.CanvasState[1]], ldc.InputLabels, ldc.OutputLabels, ldc.LCParameterSlots, ldc.Form, ldc.LoadedComponentIsOutOfDate, ldc.Description, ldc.IsTopSheet, ldc.ArrayInfo)), filter((x_1) => (x_1.Name !== sheetName), p.LoadedComponents)), singleton(target_ldc$0027)));
            const model$0027_1 = new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, p$0027, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState);
            dispatch(new Msg(/* SetProject */ 39, [p$0027]));
            saveOpenFileActionWithModelUpdate(model$0027_1, dispatch);
        }
        else {
            toFail(printf("Can\'t happen"));
        }
        dispatch(Msg.ClosePopup);
    }, (model_2) => false, empty_1(), dispatch);
}

function createGateNPopup(gateType, model, dispatch) {
    dialogPopup(`Add N input ${gateType} gate`, dialogPopupBodyOnlyInt((_arg) => "How many inputs should the gate have?", 2, dispatch), "Add", (model$0027) => {
        createCompStdLabel(new ComponentType(/* GateN */ 10, [gateType, getInt(model$0027.PopupDialogData)]), undefined, model, dispatch);
        dispatch(Msg.ClosePopup);
    }, (model$0027_1) => {
        const intIn = getInt(model$0027_1.PopupDialogData) | 0;
        if (intIn < 2) {
            return true;
        }
        else {
            return intIn > Constants_maxGateInputs;
        }
    }, empty_1(), dispatch);
}

function createMergeNPopup(model, dispatch) {
    dialogPopup("Add N input merge", dialogPopupBodyOnlyBoundedInt((_arg) => "How many inputs should the merge component have?", 2, 2, Constants_maxSplitMergeBranches, dispatch), "Add", (model$0027) => {
        createCompStdLabel(new ComponentType(/* MergeN */ 29, [getInt(model$0027.PopupDialogData)]), undefined, model, dispatch);
        dispatch(Msg.ClosePopup);
    }, (model$0027_1) => {
        const intIn = getInt(model$0027_1.PopupDialogData) | 0;
        if (intIn < 2) {
            return true;
        }
        else {
            return intIn > Constants_maxSplitMergeBranches;
        }
    }, empty_1(), dispatch);
}

function createSplitNPopup(model, dispatch) {
    const proto = new ComponentType(/* SplitN */ 30, [2, ofArray([1, 1]), ofArray([0, 1])]);
    const boxesOf = (dialog) => concat_1(mapIndexed2((index_2, width, lsb) => ofArray([slotParam(proto, new CompSlotName(/* SplitNWidth */ 3, [index_2]), "", width), slotParam(proto, new CompSlotName(/* SplitNLSB */ 4, [index_2]), "", lsb)]), getIntList(dialog, 2, 1), getIntList2(dialog, 2, 0)));
    dialogPopup("Add N output split", dialogPopupBodyNInts((_arg) => "How many outputs should the split component have?", 2, 1, Constants_maxSplitMergeBranches, uncurry3((index) => ((defaultWidth) => {
        const box = slotParam(proto, new CompSlotName(/* SplitNWidth */ 3, [index]), "", defaultWidth);
        return (model$0027) => paramBox(dispatch, box, model$0027);
    })), uncurry3((index_1) => ((defaultLSB) => {
        const box_1 = slotParam(proto, new CompSlotName(/* SplitNLSB */ 4, [index_1]), "", defaultLSB);
        return (model$0027_1) => paramBox(dispatch, box_1, model$0027_1);
    })), dispatch), "Add", (model$0027_2) => {
        const dialogData = model$0027_2.PopupDialogData;
        const matchValue = paramBoxValues(dialogData, boxesOf(dialogData));
        if (matchValue.tag === 0) {
            let patternInput;
            const tupledArg_1 = partition((tupledArg) => ((tupledArg[0] % 2) === 0), indexed(matchValue.fields[0]));
            patternInput = [map((tuple) => tuple[1], tupledArg_1[0]), map((tuple_1) => tuple_1[1], tupledArg_1[1])];
            const widths_1 = patternInput[0];
            const lsbs_1 = patternInput[1];
            createCompStdLabel(new ComponentType(/* SplitN */ 30, [getInt(dialogData), paramBoxInts(widths_1), paramBoxInts(lsbs_1)]), paramSlotsOf(dispatch, append(widths_1, lsbs_1)), model, dispatch);
            dispatch(Msg.ClosePopup);
        }
    }, (model$0027_3) => {
        const dialogData_1 = model$0027_3.PopupDialogData;
        const intIn = getInt(dialogData_1) | 0;
        if ((intIn < 2) ? true : (intIn > Constants_maxSplitMergeBranches)) {
            return true;
        }
        else {
            return Result_IsError(paramBoxValues(dialogData_1, boxesOf(dialogData_1)));
        }
    }, empty_1(), dispatch);
}

function createArithmeticPopup(compType, model, dispatch) {
    const patternInput = (compType.tag === 17) ? ["adder", (BusWidth) => (new ComponentType(/* NbitsAdder */ 17, [BusWidth]))] : ((compType.tag === 21) ? ["XOR", (n) => (new ComponentType(/* NbitsXor */ 21, [n, undefined]))] : ((compType.tag === 22) ? ["AND", (BusWidth_1) => (new ComponentType(/* NbitsAnd */ 22, [BusWidth_1]))] : ((compType.tag === 24) ? ["OR", (BusWidth_2) => (new ComponentType(/* NbitsOr */ 24, [BusWidth_2]))] : ((compType.tag === 23) ? ["NOT", (BusWidth_3) => (new ComponentType(/* NbitsNot */ 23, [BusWidth_3]))] : toFail(`Invalid component type ${compType} for arithmetic popup`)))));
    const compName = patternInput[0];
    const title = concat("Add N bits ", compName);
    const slot = CompSlotName.Buswidth;
    const widthDefault = fromInt32(model.LastUsedDialogWidth);
    const constraints = ofArray([new ParamConstraint(/* MinVal */ 0, [new ParamExpression(/* PInt */ 0, [fromOne()]), concat("Number of bits in ", compName, " must be positive")]), new ParamConstraint(/* MaxVal */ 1, [new ParamExpression(/* PInt */ 0, [fromInt32(Constants_maxIssieBusWidth)]), `Number of bits in ${compName} cannot exceed ${Constants_maxIssieBusWidth}`])]);
    const defaultParamSpec = new NewParamCompSpec(slot, new ParamExpression(/* PInt */ 0, [widthDefault]), constraints, widthDefault);
    dispatch(new Msg(/* AddPopupDialogParamSpec */ 63, [[paramBoxKey(undefined, slot), new ParamBoxState(renderParamExpression(defaultParamSpec.Expression, 0), new FSharpResult$2(/* Ok */ 0, [defaultParamSpec]))]]));
    dialogPopup(title, (model$0027) => paramInputField(model$0027, "How many bits should the input/output have?", widthDefault, undefined, undefined, constraints, undefined, undefined, slot, dispatch), "Add", (model$0027_1) => {
        let inputFieldDialog;
        const matchValue = model$0027_1.PopupDialogData.DialogState;
        if (matchValue == null) {
            inputFieldDialog = toFail(printf("Param input field must set new param info"));
        }
        else {
            const inputSpec = matchValue;
            inputFieldDialog = find_1(paramBoxKey(undefined, slot), inputSpec).Spec;
        }
        const compParamSpec = (inputFieldDialog.tag === 1) ? toFail(`Received error message '${inputFieldDialog.fields[0]}' when creating N-bits ${compName}`) : inputFieldDialog.fields[0];
        const width = intOfParamInt(1, compParamSpec.Value) | 0;
        createCompStdLabel(patternInput[1](width), (compId) => {
            addParamComponent(compParamSpec, dispatch, compId);
        }, model, dispatch);
        dispatch(new Msg(/* ReloadSelectedComponent */ 87, [width]));
        dispatch(Msg.ClosePopup);
    }, (model$0027_2) => {
        const _arg = model$0027_2.PopupDialogData.DialogState;
        if (_arg == null) {
            return toFail(printf("Dialog state must exist for input box"));
        }
        else {
            const specs = _arg;
            return Result_IsError(find_1(paramBoxKey(undefined, slot), specs).Spec);
        }
    }, empty_1(), dispatch);
}

function createShiftPopup(model, dispatch) {
    const slot = CompSlotName.Buswidth;
    const widthDefault = fromInt32(model.LastUsedDialogWidth);
    const constraints = ofArray([new ParamConstraint(/* MinVal */ 0, [new ParamExpression(/* PInt */ 0, [fromOne()]), "Number of bits in shift must be positive"]), new ParamConstraint(/* MaxVal */ 1, [new ParamExpression(/* PInt */ 0, [fromInt32(Constants_maxIssieBusWidth)]), `Number of bits in shift cannot exceed ${Constants_maxIssieBusWidth}`])]);
    const defaultParamSpec = new NewParamCompSpec(slot, new ParamExpression(/* PInt */ 0, [widthDefault]), constraints, widthDefault);
    const shiftKinds = ofArray([[ShiftComponentType.LSL, fromZero(), "LSL", "logical shift left"], [ShiftComponentType.LSR, fromOne(), "LSR", "logical shift right"], [ShiftComponentType.ASR, fromInt32(2), "ASR", "arithmetic shift right"]]);
    const chosenKind = (model$0027) => defaultArg(tryPick((tupledArg) => {
        if (equals(model$0027.PopupDialogData.Int2, tupledArg[1])) {
            return tupledArg[0];
        }
        else {
            return undefined;
        }
    }, shiftKinds), ShiftComponentType.LSL);
    dispatch(new Msg(/* SetPopupDialogInt2 */ 58, [fromZero()]));
    dispatch(new Msg(/* AddPopupDialogParamSpec */ 63, [[paramBoxKey(undefined, slot), new ParamBoxState(renderParamExpression(defaultParamSpec.Expression, 0), new FSharpResult$2(/* Ok */ 0, [defaultParamSpec]))]]));
    dialogPopup("Add N bits shift", (model$0027_1) => {
        const children = [paramInputField(model$0027_1, "How many bits should the input/output have?", widthDefault, undefined, undefined, constraints, undefined, undefined, slot, dispatch), react_1.createElement("br", {}), "Which kind of shift?", react_1.createElement("br", {}), react_1.createElement("br", {}), div(singleton(Option_2.HasAddons), map((tupledArg_1) => div_1(empty_1(), singleton(button(ofArray([new Option_3(/* Color */ 0, [equals(chosenKind(model$0027_1), tupledArg_1[0]) ? Color_IColor.IsPrimary : Color_IColor.IsLight]), new Option_3(/* OnClick */ 18, [(_arg_2) => {
            dispatch(new Msg(/* SetPopupDialogInt2 */ 58, [tupledArg_1[1]]));
        }])]), singleton(concat(tupledArg_1[2], ": ", tupledArg_1[3]))))), shiftKinds))];
        return react_1.createElement("div", {}, ...children);
    }, "Add", (model$0027_2) => {
        let inputFieldDialog;
        const matchValue = model$0027_2.PopupDialogData.DialogState;
        if (matchValue == null) {
            inputFieldDialog = toFail(printf("Param input field must set new param info"));
        }
        else {
            const inputSpec = matchValue;
            inputFieldDialog = find_1(paramBoxKey(undefined, slot), inputSpec).Spec;
        }
        const compParamSpec = (inputFieldDialog.tag === 1) ? toFail(`Received error message '${inputFieldDialog.fields[0]}' when creating N-bits shift`) : inputFieldDialog.fields[0];
        const w = intOfParamInt(1, compParamSpec.Value) | 0;
        createCompStdLabel(new ComponentType(/* Shift */ 46, [w, shifterWidthFor(w), chosenKind(model$0027_2)]), (compId) => {
            addParamComponent(compParamSpec, dispatch, compId);
        }, model, dispatch);
        dispatch(new Msg(/* ReloadSelectedComponent */ 87, [w]));
        dispatch(Msg.ClosePopup);
    }, (model$0027_3) => {
        const _arg_3 = model$0027_3.PopupDialogData.DialogState;
        if (_arg_3 == null) {
            return toFail(printf("Dialog state must exist for input box"));
        }
        else {
            const specs = _arg_3;
            return Result_IsError(find_1(paramBoxKey(undefined, slot), specs).Spec);
        }
    }, empty_1(), dispatch);
}

function createNbitSpreaderPopup(model, dispatch) {
    const title = toText(printf("Add 1-to-N bit spreader"));
    const width = slotParam(new ComponentType(/* NbitSpreader */ 25, [1]), CompSlotName.Buswidth, "How many bits should the output bus contain?", model.LastUsedDialogWidth);
    dialogPopup(title, (model$0027_2) => paramBox(dispatch, width, model$0027_2), "Add", (model$0027) => {
        const matchValue = paramBoxValues(model$0027.PopupDialogData, singleton(width));
        if (matchValue.tag === 0) {
            const specs = matchValue.fields[0];
            const outputWidth = head(paramBoxInts(specs)) | 0;
            createCompStdLabel(new ComponentType(/* NbitSpreader */ 25, [outputWidth]), paramSlotsOf(dispatch, specs), new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, outputWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState), dispatch);
            dispatch(Msg.ClosePopup);
        }
    }, (model$0027_1) => Result_IsError(paramBoxValues(model$0027_1.PopupDialogData, singleton(width))), empty_1(), dispatch);
}

function createSplitWirePopup(model, dispatch) {
    const title = toText(printf("Add SplitWire node"));
    const topWidth = slotParam(new ComponentType(/* SplitWire */ 28, [1]), CompSlotName.Buswidth, "How many bits should go to the top (LSB) wire? The remaining bits will go to the bottom (MSB) wire. Use Edit -> Flip Vertically after placing component to swap top and bottom", 1);
    dialogPopup(title, (model$0027_2) => paramBox(dispatch, topWidth, model$0027_2), "Add", (model$0027) => {
        const matchValue = paramBoxValues(model$0027.PopupDialogData, singleton(topWidth));
        if (matchValue.tag === 0) {
            const specs = matchValue.fields[0];
            createCompStdLabel(new ComponentType(/* SplitWire */ 28, [head(paramBoxInts(specs))]), paramSlotsOf(dispatch, specs), model, dispatch);
            dispatch(Msg.ClosePopup);
        }
    }, (model$0027_1) => Result_IsError(paramBoxValues(model$0027_1.PopupDialogData, singleton(topWidth))), empty_1(), dispatch);
}

function twoErrorLines(errMsg1, errMsg2) {
    const props_4 = [["style", {
        color: HighLightColor.Red,
    }]];
    const children = [errMsg1, react_1.createElement("br", {}), errMsg2, react_1.createElement("br", {})];
    return react_1.createElement("span", keyValueList(props_4, 1), ...children);
}

/**
 * two line message giving constant value
 */
export function constantValueMessage(w, cVal) {
    const uVal = op_BitwiseAnd(cVal, op_Subtraction(op_LeftShift(fromOne(), w), fromOne()));
    const sVal = !equals_1(op_BitwiseAnd(cVal, op_LeftShift(fromOne(), w - 1)), fromZero()) ? op_Subtraction(uVal, op_LeftShift(fromOne(), w)) : uVal;
    const line2 = concat("Hex value: ", BigIntToPaddedString(Constants_maxNumericCharsBeforeTruncation, NumberBase.Hex, w, uVal));
    const children = [`Decimal value: ${uVal} (${sVal} signed)`, react_1.createElement("br", {}), line2, react_1.createElement("br", {})];
    return react_1.createElement("span", {}, ...children);
}

/**
 * two line message giving constant value
 */
export function busCompareValueMessage(w, cVal) {
    const uVal = op_BitwiseAnd(cVal, op_Subtraction(op_LeftShift(fromOne(), w), fromOne()));
    const sVal = equals_1(op_BitwiseAnd(uVal, op_LeftShift(fromOne(), w - 1)), fromZero()) ? uVal : op_Subtraction(op_LeftShift(fromOne(), w), uVal);
    const line2 = concat("Hex value: ", BigIntToPaddedString(Constants_maxNumericCharsBeforeTruncation, NumberBase.Hex, w, uVal));
    const children = [`Decimal value: ${uVal} (${sVal} signed)`, react_1.createElement("br", {}), line2, react_1.createElement("br", {})];
    return react_1.createElement("span", {}, ...children);
}

/**
 * check constant parameters and return two react lines with
 * error message or value details.
 */
export function parseConstant(wMax, w, cText) {
    if ((w < 1) ? true : (w > wMax)) {
        return [twoErrorLines(`Constant width must be in the range 1..${wMax}`, ""), undefined];
    }
    else {
        const matchValue = strToIntCheckWidth(w, cText);
        if (matchValue.tag === 1) {
            return [twoErrorLines(matchValue.fields[0], ""), undefined];
        }
        else {
            const n = matchValue.fields[0];
            return [constantValueMessage(w, n), new ComponentType(/* Constant1 */ 7, [w, n, cText])];
        }
    }
}

export function parseBusCompareValue(wMax, w, cText) {
    if ((w < 1) ? true : (w > wMax)) {
        return [twoErrorLines(`Bus Compare width must be in the range 1..${wMax}`, ""), undefined];
    }
    else {
        const matchValue = strToIntCheckWidth(w, cText);
        if (matchValue.tag === 1) {
            return [twoErrorLines(matchValue.fields[0], ""), undefined];
        }
        else {
            const n = matchValue.fields[0];
            return [busCompareValueMessage(w, n), new ComponentType(/* BusCompare1 */ 5, [w, n, cText])];
        }
    }
}

function createConstantPopup(model, dispatch) {
    const title = toText(printf("Add Constant"));
    const width = slotParam(new ComponentType(/* Constant1 */ 7, [1, fromZero(), ""]), CompSlotName.Buswidth, "How many bits has the wire carrying the constant?", 1);
    const valueOf = (dialog_1) => {
        let matchValue;
        return slotParam(new ComponentType(/* Constant1 */ 7, [(matchValue = paramBoxValues(dialog_1, singleton(width)), (matchValue.tag === 1) ? 1 : intOfParamInt(1, head(matchValue.fields[0]).Value)), fromZero(), ""]), new CompSlotName(/* IO */ 1, ["value"]), "Constant value (decimal, 0x hex, 0b binary, or a property expression)", 0);
    };
    const boxesOf = (dialog_2) => ofArray([width, valueOf(dialog_2)]);
    dialogPopup(title, (model$0027) => {
        const dialog_3 = model$0027.PopupDialogData;
        const children = toList(delay(() => append_1(singleton_1(paramBox(dispatch, width, model$0027)), delay(() => append_1(singleton_1(paramBox(dispatch, valueOf(dialog_3), model$0027)), delay(() => {
            const matchValue_1 = paramBoxValues(dialog_3, boxesOf(dialog_3));
            let matchResult, v, w;
            if (matchValue_1.tag === 0) {
                if (!isEmpty_1(matchValue_1.fields[0])) {
                    if (!isEmpty_1(tail(matchValue_1.fields[0]))) {
                        if (isEmpty_1(tail(tail(matchValue_1.fields[0])))) {
                            matchResult = 0;
                            v = head(tail(matchValue_1.fields[0]));
                            w = head(matchValue_1.fields[0]);
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return singleton_1(constantValueMessage(intOfParamInt(1, w.Value), v.Value));
                default:
                    return singleton_1(defaultOf());
            }
        }))))));
        return react_1.createElement("div", {}, ...children);
    }, "Add", (model$0027_1) => {
        const dialog_4 = model$0027_1.PopupDialogData;
        const matchValue_2 = paramBoxValues(dialog_4, boxesOf(dialog_4));
        let matchResult_1, v_1, w_1;
        if (matchValue_2.tag === 0) {
            if (!isEmpty_1(matchValue_2.fields[0])) {
                if (!isEmpty_1(tail(matchValue_2.fields[0]))) {
                    if (isEmpty_1(tail(tail(matchValue_2.fields[0])))) {
                        matchResult_1 = 0;
                        v_1 = head(tail(matchValue_2.fields[0]));
                        w_1 = head(matchValue_2.fields[0]);
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                createCompStdLabel(new ComponentType(/* Constant1 */ 7, [intOfParamInt(1, w_1.Value), v_1.Value, toString(v_1.Value)]), paramSlotsOf(dispatch, ofArray([w_1, v_1])), model, dispatch);
                dispatch(Msg.ClosePopup);
                break;
            }
            case 1: {
                break;
            }
        }
    }, (model$0027_2) => Result_IsError(paramBoxValues(model$0027_2.PopupDialogData, boxesOf(model$0027_2.PopupDialogData))), empty_1(), dispatch);
}

function createBusSelectPopup(model, dispatch) {
    const title = toText(printf("Add Bus Selection node"));
    const boxes = ofArray([slotParam(new ComponentType(/* BusSelection */ 6, [1, 0]), CompSlotName.Buswidth, "How many bits width is the output bus?", 1), slotParam(new ComponentType(/* BusSelection */ 6, [1, 0]), new CompSlotName(/* IO */ 1, ["LSB"]), "Which input bit is the least significant output bit?", 0)]);
    dialogPopup(title, (model$0027) => {
        const children = map((box) => paramBox(dispatch, box, model$0027), boxes);
        return react_1.createElement("div", {}, ...children);
    }, "Add", (model$0027_1) => {
        const matchValue = paramBoxValues(model$0027_1.PopupDialogData, boxes);
        if (matchValue.tag === 0) {
            const specs = matchValue.fields[0];
            const matchValue_1 = paramBoxInts(specs);
            let matchResult, lsbInt, widthInt;
            if (!isEmpty_1(matchValue_1)) {
                if (!isEmpty_1(tail(matchValue_1))) {
                    if (isEmpty_1(tail(tail(matchValue_1)))) {
                        matchResult = 0;
                        lsbInt = head(tail(matchValue_1));
                        widthInt = head(matchValue_1);
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    createCompStdLabel(new ComponentType(/* BusSelection */ 6, [widthInt, lsbInt]), paramSlotsOf(dispatch, specs), model, dispatch);
                    dispatch(Msg.ClosePopup);
                    break;
                }
                case 1: {
                    toFail(printf("Bus selection has exactly two boxes"));
                    break;
                }
            }
        }
    }, (model$0027_2) => Result_IsError(paramBoxValues(model$0027_2.PopupDialogData, boxes)), empty_1(), dispatch);
}

function createBusComparePopup(model, dispatch) {
    const title = toText(printf("Add Bus Compare node"));
    const width = slotParam(new ComponentType(/* BusCompare1 */ 5, [1, fromZero(), ""]), CompSlotName.Buswidth, "How many bits width is the input bus?", 1);
    const valueOf = (dialog_1) => {
        let matchValue;
        return slotParam(new ComponentType(/* BusCompare1 */ 5, [(matchValue = paramBoxValues(dialog_1, singleton(width)), (matchValue.tag === 1) ? 1 : intOfParamInt(1, head(matchValue.fields[0]).Value)), fromZero(), ""]), new CompSlotName(/* IO */ 1, ["value"]), "Compare with (decimal, 0x hex, 0b binary, or a property expression)", 0);
    };
    const boxesOf = (dialog_2) => ofArray([width, valueOf(dialog_2)]);
    dialogPopup(title, (model$0027) => {
        const dialog_3 = model$0027.PopupDialogData;
        const children = toList(delay(() => append_1(singleton_1(paramBox(dispatch, width, model$0027)), delay(() => append_1(singleton_1(paramBox(dispatch, valueOf(dialog_3), model$0027)), delay(() => {
            const matchValue_1 = paramBoxValues(dialog_3, boxesOf(dialog_3));
            let matchResult, v, w;
            if (matchValue_1.tag === 0) {
                if (!isEmpty_1(matchValue_1.fields[0])) {
                    if (!isEmpty_1(tail(matchValue_1.fields[0]))) {
                        if (isEmpty_1(tail(tail(matchValue_1.fields[0])))) {
                            matchResult = 0;
                            v = head(tail(matchValue_1.fields[0]));
                            w = head(matchValue_1.fields[0]);
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return singleton_1(busCompareValueMessage(intOfParamInt(1, w.Value), v.Value));
                default:
                    return singleton_1(defaultOf());
            }
        }))))));
        return react_1.createElement("div", {}, ...children);
    }, "Add", (model$0027_1) => {
        const dialog_4 = model$0027_1.PopupDialogData;
        const matchValue_2 = paramBoxValues(dialog_4, boxesOf(dialog_4));
        let matchResult_1, v_1, w_1;
        if (matchValue_2.tag === 0) {
            if (!isEmpty_1(matchValue_2.fields[0])) {
                if (!isEmpty_1(tail(matchValue_2.fields[0]))) {
                    if (isEmpty_1(tail(tail(matchValue_2.fields[0])))) {
                        matchResult_1 = 0;
                        v_1 = head(tail(matchValue_2.fields[0]));
                        w_1 = head(matchValue_2.fields[0]);
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                createCompStdLabel(new ComponentType(/* BusCompare1 */ 5, [intOfParamInt(1, w_1.Value), v_1.Value, toString(v_1.Value)]), paramSlotsOf(dispatch, ofArray([w_1, v_1])), model, dispatch);
                dispatch(Msg.ClosePopup);
                break;
            }
            case 1: {
                break;
            }
        }
    }, (model$0027_2) => Result_IsError(paramBoxValues(model$0027_2.PopupDialogData, boxesOf(model$0027_2.PopupDialogData))), empty_1(), dispatch);
}

function createRegisterPopup(regType, model, dispatch) {
    const title = (regType.tag === 33) ? toText(printf("Add Register")) : ((regType.tag === 34) ? toText(printf("Add Register with Enable")) : ((regType.tag === 35) ? toText(printf("Add Counter")) : toFail(printf("Invalid register type"))));
    const prompt = (regType.tag === 33) ? "How wide should the register be (in bits)?" : ((regType.tag === 34) ? "How wide should the register be (in bits)?" : ((regType.tag === 35) ? "How wide should the counter be (in bits)?" : toFail(printf("Invalid register type"))));
    const slot = CompSlotName.Buswidth;
    const widthDefault = fromInt32(model.LastUsedDialogWidth);
    const constraints = ofArray([new ParamConstraint(/* MinVal */ 0, [new ParamExpression(/* PInt */ 0, [fromOne()]), "Register width must be positive"]), new ParamConstraint(/* MaxVal */ 1, [new ParamExpression(/* PInt */ 0, [fromInt32(Constants_maxIssieBusWidth)]), `Register width cannot exceed ${Constants_maxIssieBusWidth}`])]);
    const defaultParamSpec = new NewParamCompSpec(slot, new ParamExpression(/* PInt */ 0, [widthDefault]), constraints, widthDefault);
    dispatch(new Msg(/* AddPopupDialogParamSpec */ 63, [[paramBoxKey(undefined, slot), new ParamBoxState(renderParamExpression(defaultParamSpec.Expression, 0), new FSharpResult$2(/* Ok */ 0, [defaultParamSpec]))]]));
    dialogPopup(title, (model$0027) => paramInputField(model$0027, prompt, widthDefault, undefined, undefined, constraints, undefined, undefined, slot, dispatch), "Add", (model$0027_1) => {
        let inputFieldDialog;
        const matchValue = model$0027_1.PopupDialogData.DialogState;
        if (matchValue == null) {
            inputFieldDialog = toFail(printf("Param input field must set new param info"));
        }
        else {
            const inputSpec = matchValue;
            inputFieldDialog = find_1(paramBoxKey(undefined, slot), inputSpec).Spec;
        }
        const compParamSpec = (inputFieldDialog.tag === 1) ? toFail(`Received error message ${inputFieldDialog.fields[0]} when creating N-bits XOR`) : inputFieldDialog.fields[0];
        const addParamCompFunction = (compId) => {
            addParamComponent(compParamSpec, dispatch, compId);
        };
        const regWidth = intOfParamInt(1, compParamSpec.Value) | 0;
        switch (regType.tag) {
            case 33: {
                createCompStdLabel(new ComponentType(/* Register */ 33, [regWidth]), addParamCompFunction, model, dispatch);
                break;
            }
            case 34: {
                createCompStdLabel(new ComponentType(/* RegisterE */ 34, [regWidth]), addParamCompFunction, model, dispatch);
                break;
            }
            case 35: {
                createCompStdLabel(new ComponentType(/* Counter */ 35, [regWidth]), addParamCompFunction, model, dispatch);
                break;
            }
            default:
                toFail(printf("Invalid register type"));
        }
        dispatch(Msg.ClosePopup);
    }, (model$0027_2) => {
        const _arg = model$0027_2.PopupDialogData.DialogState;
        if (_arg == null) {
            return toFail(printf("Dialog state must exist for input box"));
        }
        else {
            const specs = _arg;
            return Result_IsError(find_1(paramBoxKey(undefined, slot), specs).Spec);
        }
    }, empty_1(), dispatch);
}

function createMemoryPopup(memType, model, dispatch) {
    const intDefault = model.LastUsedDialogWidth | 0;
    const addError = (errorOpt, memSetup) => {
        if (memSetup != null) {
            return [memSetup[0], memSetup[1], memSetup[2], errorOpt];
        }
        else {
            return undefined;
        }
    };
    const protoMemory = memType(new Memory1(InitMemData.FromData, 1, 1, empty({
        Compare: (x, y) => (compare_1(x, y) | 0),
    }), undefined));
    const addressWidth = slotParam(protoMemory, CompSlotName.MemoryAddressWidth, "How many bits should be used to address the data in memory?", 4);
    const wordWidth = slotParam(protoMemory, CompSlotName.MemoryWordWidth, "How many bits should each memory word contain?", intDefault);
    const boxes = ofArray([addressWidth, wordWidth]);
    dialogPopup("Create memory", (model_1) => dialogPopupBodyMemorySetup(intDefault, (model$0027) => paramBox(dispatch, addressWidth, model$0027), (model$0027_1) => paramBox(dispatch, wordWidth, model$0027_1), (dialog) => {
        const matchValue = paramBoxValues(dialog, boxes);
        if (matchValue.tag === 1) {
            return undefined;
        }
        else {
            const matchValue_1 = paramBoxInts(matchValue.fields[0]);
            let matchResult, addr, word;
            if (!isEmpty_1(matchValue_1)) {
                if (!isEmpty_1(tail(matchValue_1))) {
                    if (isEmpty_1(tail(tail(matchValue_1)))) {
                        matchResult = 0;
                        addr = head(matchValue_1);
                        word = head(tail(matchValue_1));
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return [addr, word];
                default:
                    return undefined;
            }
        }
    }, dispatch, model_1), "Add", (model$0027_2) => {
        const dialogData = model$0027_2.PopupDialogData;
        const patternInput = getMemorySetup(dialogData, intDefault);
        const memory = initialiseMem(new Memory1(patternInput[2], patternInput[0], patternInput[1], empty({
            Compare: (x_1, y_1) => (compare_1(x_1, y_1) | 0),
        }), undefined), dialogData.ProjectPath);
        const matchValue_2 = paramBoxValues(dialogData, boxes);
        let matchResult_1, mem_1, specs_1, mess;
        const copyOfStruct = memory;
        if (copyOfStruct.tag === 1) {
            if (matchValue_2.tag === 1) {
                matchResult_1 = 1;
            }
            else {
                matchResult_1 = 2;
                mess = copyOfStruct.fields[0];
            }
        }
        else {
            const copyOfStruct_2 = matchValue_2;
            if (copyOfStruct_2.tag === 1) {
                matchResult_1 = 1;
            }
            else {
                matchResult_1 = 0;
                mem_1 = copyOfStruct.fields[0];
                specs_1 = copyOfStruct_2.fields[0];
            }
        }
        switch (matchResult_1) {
            case 0: {
                createCompStdLabel(memType(mem_1), paramSlotsOf(dispatch, specs_1), model, dispatch);
                dispatch(Msg.ClosePopup);
                break;
            }
            case 1: {
                break;
            }
            case 2: {
                dispatch(new Msg(/* SetPopupDialogMemorySetup */ 68, [addError(mess, dialogData.MemorySetup)]));
                break;
            }
        }
    }, (model$0027_3) => {
        const dialogData_1 = model$0027_3.PopupDialogData;
        const addressWidth_2 = getMemorySetup(dialogData_1, 1)[0] | 0;
        let error;
        const matchValue_4 = dialogData_1.MemorySetup;
        let matchResult_2;
        if (matchValue_4 == null) {
            matchResult_2 = 1;
        }
        else {
            switch (matchValue_4[2].tag) {
                case 3: {
                    matchResult_2 = 0;
                    break;
                }
                case 5:
                case 4: {
                    matchResult_2 = 2;
                    break;
                }
                default:
                    matchResult_2 = 3;
            }
        }
        switch (matchResult_2) {
            case 0: {
                error = "File name must be alphanumeric without prefix";
                break;
            }
            case 1: {
                error = "";
                break;
            }
            case 2: {
                error = (((addressWidth_2 % 2) !== 0) ? "The address width must be even for a multiplier" : ((addressWidth_2 > 16) ? "The maximum multiplier size is 8X8 - 16 address bits" : undefined));
                break;
            }
            default:
                error = undefined;
        }
        let matchResult_3, msg_1;
        if (error != null) {
            if (error !== "") {
                matchResult_3 = 0;
                msg_1 = error;
            }
            else {
                matchResult_3 = 1;
            }
        }
        else {
            matchResult_3 = 1;
        }
        switch (matchResult_3) {
            case 0: {
                const matchValue_5 = dialogData_1.MemorySetup;
                let matchResult_4, e_1;
                if (matchValue_5 != null) {
                    if (equals(matchValue_5[3], msg_1)) {
                        matchResult_4 = 0;
                        e_1 = matchValue_5[3];
                    }
                    else {
                        matchResult_4 = 1;
                    }
                }
                else {
                    matchResult_4 = 1;
                }
                switch (matchResult_4) {
                    case 1: {
                        dispatch(new Msg(/* SetPopupDialogMemorySetup */ 68, [addError(msg_1, dialogData_1.MemorySetup)]));
                        break;
                    }
                }
                break;
            }
        }
        if (!equals(error, undefined)) {
            return true;
        }
        else {
            return Result_IsError(paramBoxValues(dialogData_1, boxes));
        }
    }, empty_1(), dispatch);
}

export function createVerilogPopup(model, showExtraErrors, correctedCode, moduleName, origin, dispatch) {
    const title = toText(printf("Create Combinational or Synchronous Components using Verilog"));
    const noErrors = isEmpty_1(model.PopupDialogData.VerilogErrors);
    const errorDiv = noErrors ? defaultOf() : getErrorDiv(model.PopupDialogData.VerilogErrors);
    const errorList = showExtraErrors ? model.PopupDialogData.VerilogErrors : empty_1();
    const extra = showExtraErrors ? ofArray([new CSSProp(/* Width */ 395, ["80%"]), new CSSProp(/* Height */ 189, ["75%"]), new CSSProp(/* OverflowX */ 271, ["hidden"]), new CSSProp(/* Position */ 291, ["fixed"])]) : ofArray([new CSSProp(/* Width */ 395, ["50%"]), new CSSProp(/* Height */ 189, ["75%"]), new CSSProp(/* OverflowX */ 271, ["hidden"]), new CSSProp(/* Position */ 291, ["fixed"])]);
    dialogVerilogPopup(title, (model_1) => dialogVerilogCompBody((_arg) => toText(printf("ISSIE Component Name")), moduleName, errorDiv, errorList, showExtraErrors, correctedCode, (dialogData_2) => {
        const matchValue_10 = model.CurrentProj;
        if (matchValue_10 != null) {
            const project_2 = matchValue_10;
            const code_2 = getCode(dialogData_2);
            let output_2;
            const matchValue_11 = SimpleJson_tryParse(parseFromFile(code_2));
            if (matchValue_11 != null) {
                output_2 = Convert_fromJson(matchValue_11, createTypeInfo(ParserOutput_$reflection()));
            }
            else {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            }
            if (output_2.Error == null) {
                if (output_2.Result == null) {
                }
                else {
                    const result_3 = value_4(output_2.Result);
                    const fixedAST_2 = fix(result_3);
                    const linesIndex = ofArray(value_4(output_2.NewLinesIndex));
                    let parsedAST_2;
                    const matchValue_13 = SimpleJson_tryParse(fixedAST_2);
                    if (matchValue_13 != null) {
                        parsedAST_2 = Convert_fromJson(matchValue_13, createTypeInfo(VerilogInput_$reflection()));
                    }
                    else {
                        throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
                    }
                    const errorList_1 = getSemanticErrors(parsedAST_2, linesIndex, origin, project_2);
                    createVerilogPopup(new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, new PopupDialogData(dialogData_2.Text, dialogData_2.Text2, dialogData_2.Int, dialogData_2.ImportDecisions, dialogData_2.Int2, dialogData_2.Int3, dialogData_2.ProjectPath, dialogData_2.MemorySetup, dialogData_2.MemoryEditorData, dialogData_2.Progress, dialogData_2.ConstraintTypeSel, dialogData_2.ConstraintIOSel, dialogData_2.ConstraintErrorMsg, dialogData_2.NewConstraint, dialogData_2.AlgebraInputs, dialogData_2.AlgebraError, code_2, errorList_1, dialogData_2.BadLabel, dialogData_2.IntList, dialogData_2.IntList2, dialogData_2.DialogState), model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState), isEmpty_1(errorList_1) ? showExtraErrors : showExtraErrors, undefined, parsedAST_2.Module.ModuleName.Name, origin, dispatch);
                }
            }
            else {
                createVerilogPopup(new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, new PopupDialogData(dialogData_2.Text, dialogData_2.Text2, dialogData_2.Int, dialogData_2.ImportDecisions, dialogData_2.Int2, dialogData_2.Int3, dialogData_2.ProjectPath, dialogData_2.MemorySetup, dialogData_2.MemoryEditorData, dialogData_2.Progress, dialogData_2.ConstraintTypeSel, dialogData_2.ConstraintIOSel, dialogData_2.ConstraintErrorMsg, dialogData_2.NewConstraint, dialogData_2.AlgebraInputs, dialogData_2.AlgebraError, dialogData_2.VerilogCode, singleton(getSyntaxErrorInfo(value_4(output_2.Error))), dialogData_2.BadLabel, dialogData_2.IntList, dialogData_2.IntList2, dialogData_2.DialogState), model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState), showExtraErrors, undefined, moduleName, origin, dispatch);
            }
        }
        else {
            toFail(printf("What? current project cannot be None at this point in compiling Verilog Component"));
        }
    }, (dialogData_3, tupledArg) => {
        let oldCode_1, suggestion_1, replaceType_1, line_1, linesList, untilError_1, fixedLine, originalString, startIndex, length;
        const replaceType = tupledArg[1];
        const findLastIOAndAssignment = (oldCode) => {
            const isSmallerThan = (x, y) => (compare(y, x) <= 0);
            let output_3;
            const matchValue_15 = SimpleJson_tryParse(parseFromFile(oldCode));
            if (matchValue_15 != null) {
                output_3 = Convert_fromJson(matchValue_15, createTypeInfo(ParserOutput_$reflection()));
            }
            else {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            }
            const result_4 = value_4(output_3.Result);
            const fixedAST_3 = fix(result_4);
            const linesIndex_1 = ofArray(value_4(output_3.NewLinesIndex));
            let parsedAST_3;
            const matchValue_16 = SimpleJson_tryParse(fixedAST_3);
            if (matchValue_16 != null) {
                parsedAST_3 = Convert_fromJson(matchValue_16, createTypeInfo(VerilogInput_$reflection()));
            }
            else {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            }
            const lastIODecl = tryLast(parsedAST_3.Module.ModuleItems.ItemList.filter((item) => (item.IODecl != null)));
            const lastIOLocation = ((lastIODecl == null) ? 1 : lastIODecl.Location) | 0;
            const prevIndexIO = findIndexBack((x_1) => isSmallerThan(lastIOLocation, x_1), linesIndex_1) | 0;
            const lastAssignment = tryLast(parsedAST_3.Module.ModuleItems.ItemList.filter((item_1) => (item_1.Statement != null)));
            const lastAssignmentLocation = ((lastAssignment == null) ? lastIOLocation : lastAssignment.Location) | 0;
            return [prevIndexIO, findIndexBack((x_2) => isSmallerThan(lastAssignmentLocation, x_2), linesIndex_1)];
        };
        const lineToPut = ((replaceType.tag === 0) ? findLastIOAndAssignment(defaultArg(dialogData_3.VerilogCode, ""))[0] : ((replaceType.tag === 1) ? findLastIOAndAssignment(defaultArg(dialogData_3.VerilogCode, ""))[1] : tupledArg[2])) | 0;
        createVerilogPopup(model, showExtraErrors, (oldCode_1 = defaultArg(dialogData_3.VerilogCode, ""), (suggestion_1 = tupledArg[0], (replaceType_1 = replaceType, (line_1 = (lineToPut | 0), (linesList = toList(split(oldCode_1, ["\n"], undefined, 1)), (replaceType_1.tag === 1) ? fold((s_3, v_1) => ((s_3 + "\n") + item_2(v_1, linesList)), (fold((s_2, v) => ((s_2 + "\n") + item_2(v - 1, linesList)), item_2(0, linesList), toList(rangeDouble(2, 1, line_1 + 1))) + "\n  ") + suggestion_1, toList(rangeDouble(line_1 + 1, 1, length_1(linesList) - 1))) : ((replaceType_1.tag === 2) ? ((untilError_1 = fold((s_4, v_2) => {
            if (v_2 === 1) {
                return item_2(v_2 - 1, linesList);
            }
            else {
                return (s_4 + "\n") + item_2(v_2 - 1, linesList);
            }
        }, "", toList(rangeDouble(1, 1, line_1 - 1))), (fixedLine = ((originalString = item_2(line_1 - 1, linesList), (startIndex = ((tupledArg[3] - 1) | 0), (length = (replaceType_1.fields[0].length | 0), (originalString.slice(undefined, (startIndex - 1) + 1) + suggestion_1) + originalString.slice(startIndex + length, originalString.length))))), fold((s_5, v_3) => ((s_5 + "\n") + item_2(v_3, linesList)), (line_1 === 1) ? fixedLine : ((untilError_1 + "\n") + fixedLine), toList(rangeDouble(line_1, 1, length_1(linesList) - 1)))))) : ((replaceType_1.tag === 3) ? oldCode_1 : fold((s_3, v_1) => ((s_3 + "\n") + item_2(v_1, linesList)), (fold((s_2, v) => ((s_2 + "\n") + item_2(v - 1, linesList)), item_2(0, linesList), toList(rangeDouble(2, 1, line_1 + 1))) + "\n  ") + suggestion_1, toList(rangeDouble(line_1 + 1, 1, length_1(linesList) - 1)))))))))), moduleName, origin, dispatch);
    }, dispatch, model_1), (origin.tag === 1) ? "Update" : "Save", noErrors, showExtraErrors, (origin.tag === 1) ? ((dialogData_1) => {
        let matchValue_8, matchValue_9;
        const matchValue_6 = model.CurrentProj;
        if (matchValue_6 != null) {
            const project_1 = matchValue_6;
            const name_1 = value_4(moduleName);
            const path_1 = pathJoin([project_1.ProjectPath, name_1 + ".v"]);
            const code_1 = getCode(dialogData_1);
            const matchValue_7 = writeFile(path_1, code_1);
            if (matchValue_7.tag === 1) {
                toFail(printf("Writing verilog file FAILED"));
            }
            const result_2 = value_4(((matchValue_8 = SimpleJson_tryParse(parseFromFile(code_1)), (matchValue_8 != null) ? Convert_fromJson(matchValue_8, createTypeInfo(ParserOutput_$reflection())) : (() => {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            })())).Result);
            const newCS = createSheet((matchValue_9 = SimpleJson_tryParse(fix(result_2)), (matchValue_9 != null) ? Convert_fromJson(matchValue_9, createTypeInfo(VerilogInput_$reflection())) : (() => {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            })()), project_1, model, dispatch);
            dispatch(new Msg(/* StartUICmd */ 109, [UICommandType.SaveSheet]));
            updateVerilogFileActionWithModelUpdate(newCS[0], newCS[1], name_1, model, dispatch);
            dispatch(new Msg(/* Sheet */ 3, [DrawModelType_SheetT_Msg.DoNothing]));
        }
        else {
            toFail(printf("What? current project cannot be None at this point in writing Verilog Component"));
        }
    }) : ((dialogData) => {
        let matchValue_2, matchValue_3, matchValue_5;
        const matchValue = model.CurrentProj;
        if (matchValue != null) {
            const project = matchValue;
            const name = value_4(moduleName);
            const folderPath = project.ProjectPath;
            const path = pathJoin([folderPath, name + ".v"]);
            const path2 = pathJoin([folderPath, name + ".dgm"]);
            const code = getCode(dialogData);
            const matchValue_1 = writeFile(path, code);
            if (matchValue_1.tag === 1) {
                toFail(printf("Writing verilog file FAILED"));
            }
            const result = value_4(((matchValue_2 = SimpleJson_tryParse(parseFromFile(code)), (matchValue_2 != null) ? Convert_fromJson(matchValue_2, createTypeInfo(ParserOutput_$reflection())) : (() => {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            })())).Result);
            const matchValue_4 = Result_Bind((data) => writeFile(path2, data), JsonHelpers_stateToJsonString(createSheet((matchValue_3 = SimpleJson_tryParse(fix(result)), (matchValue_3 != null) ? Convert_fromJson(matchValue_3, createTypeInfo(VerilogInput_$reflection())) : (() => {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            })()), project, model, dispatch), undefined, new SheetInfo(new CCForm(/* Verilog */ 4, [name]), undefined, undefined, undefined, undefined)));
            if (matchValue_4.tag === 1) {
                toFail(printf("Writing .dgm file FAILED"));
            }
            else {
                openFileInProject(project.OpenFileName, new Project(project.ProjectPath, project.OpenFileName, project.WorkingFileName, cons((matchValue_5 = tryLoadComponentFromPath(path2), (matchValue_5.tag === 1) ? toFail(printf("failed to load the created Verilog file")) : matchValue_5.fields[0]), project.LoadedComponents)), model, dispatch);
            }
        }
        else {
            toFail(printf("What? current project cannot be None at this point in writing Verilog Component"));
        }
        dispatch(Msg.ClosePopup);
    }), (dialogData_4) => {
        const matchValue_17 = model.CurrentProj;
        if (matchValue_17 != null) {
            createVerilogPopup(model, !showExtraErrors, undefined, moduleName, origin, dispatch);
        }
        else {
            toFail(printf("What? current project cannot be None at this point in compiling Verilog Component"));
        }
    }, (dialogData_6) => {
        let s_6;
        const code_3 = getCode(dialogData_6);
        let savedCode;
        const matchValue_18 = model.CurrentProj;
        if (origin.tag === 1) {
            if (matchValue_18 == null) {
                savedCode = undefined;
            }
            else {
                const project_4 = matchValue_18;
                const matchValue_20 = tryReadFileSync(pathJoin([project_4.ProjectPath, origin.fields[0] + ".v"]));
                savedCode = ((matchValue_20.tag === 1) ? undefined : matchValue_20.fields[0]);
            }
        }
        else {
            savedCode = verilogEditorTemplate;
        }
        const close = () => {
            dispatch(Msg.ClosePopup);
            dispatch(Msg.FinishUICmd);
        };
        if ((code_3 === "") ? true : equals(savedCode, code_3)) {
            close();
        }
        else {
            choicePopup("Discard your Verilog code?", (s_6 = "This component has not been saved, so the code you have written will be lost. Compile it first if you want to keep it.", s_6), "Discard", "Keep editing", (discard, _arg_1) => {
                if (discard) {
                    close();
                }
                else {
                    createVerilogPopup(model, showExtraErrors, code_3, moduleName, origin, dispatch);
                }
            }, dispatch);
        }
    }, (dialogData_5) => !noErrors, extra, dispatch);
}

function makeMenuGroupOpen(isOpen, title, menuList) {
    if (isEmpty_1(menuList)) {
        return defaultOf();
    }
    else {
        const children_2 = [react_1.createElement("summary", keyValueList([menuLabelStyle], 1), title), list_9(empty_1(), menuList)];
        return react_1.createElement("details", {
            open: isOpen,
        }, ...children_2);
    }
}

function makeMenuGroup(title, menuList) {
    return makeMenuGroupOpen(false, title, menuList);
}

function makeMenuGroupWithTipOpen(isOpen, styles, title, tip, menuList) {
    if (isEmpty_1(menuList)) {
        return defaultOf();
    }
    else {
        const props_2 = [new HTMLAttr(/* Open */ 125, [isOpen]), new HTMLAttr(/* ClassName */ 64, [concat("tooltip", " ", "has-tooltip-multiline")]), dataTooltip(tip), ["style", keyValueList(styles, 1)]];
        const children_2 = [react_1.createElement("summary", keyValueList([menuLabelStyle], 1), title), list_9(empty_1(), menuList)];
        return react_1.createElement("details", keyValueList(props_2, 1), ...children_2);
    }
}

function makeMenuGroupWithTip(styles, title, tip, menuList) {
    return makeMenuGroupWithTipOpen(false, styles, title, tip, menuList);
}

/**
 * The component a catalogue drag is carrying, drawn following the cursor.
 * 
 * This is the draw block's own drawing - createNewSymbol and drawComponent, the pair the canvas
 * itself uses - and not a picture of one, so what is being carried cannot fall out of step with
 * what will be placed: a symbol whose look depends on its ports, its size or the theme comes out
 * right here for nothing, and stays right when that drawing changes. It is scaled by the sheet's
 * zoom for the same reason.
 * 
 * Nothing is added to any model. The symbol is built, drawn and discarded on each mouse move,
 * which is what lets the popup still stand in front of the component being created.
 * 
 * Carried over a component already on the sheet it is drawn red, because there it cannot be
 * dropped - see ghostOverlaps.
 */
export function viewDragGhost(model) {
    let props_2, props_8, children_8, props_6, children_6, props_4;
    const matchValue = model.DragPlacement;
    let matchResult, cursor, ghost;
    if (matchValue != null) {
        if (matchValue.tag === 0) {
            matchResult = 1;
            cursor = matchValue.fields[1];
            ghost = matchValue.fields[0];
        }
        else {
            matchResult = 0;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return defaultOf();
        default: {
            const zoom = model.Sheet.Zoom;
            const overlapping = ghostOverlaps(model, ghost, cursor);
            let patternInput_1;
            if (ghost.tag === 1) {
                const w = Constants_ghostBoxW;
                const h = Constants_ghostBoxH;
                const fill = overlapping ? Constants_ghostErrorColour : "lightgray";
                patternInput_1 = [ofArray([react_1.createElement("rect", {
                    width: w,
                    height: h,
                    rx: 5,
                    fill: fill,
                    stroke: "black",
                    strokeWidth: 1,
                }), (props_2 = [new SVGAttr(/* X */ 44, [w / 2]), new SVGAttr(/* Y */ 57, [h / 2]), new SVGAttr(/* TextAnchor */ 37, ["middle"]), ["dominantBaseline", "middle"], new SVGAttr(/* FontSize */ 9, ["12px"])], react_1.createElement("text", keyValueList(props_2, 1), ghost.fields[0]))]), w, h];
            }
            else {
                const placed = ghostSymbol(model, ghost.fields[0], ghost.fields[1], new XYPos(0, 0));
                const sym = overlapping ? Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_colour_)(DrawModelType_SymbolT_appearance_))(Constants_ghostErrorColour)(placed) : placed;
                patternInput_1 = [drawComponent(sym, model.Sheet.Wire.Symbol.Theme), sym.Component.W, sym.Component.H];
            }
            const svgW = (patternInput_1[1] + (2 * 40)) * zoom;
            const svgH = (patternInput_1[2] + (2 * 40)) * zoom;
            const props_10 = [["style", {
                position: "fixed",
                left: `${cursor.X - (svgW / 2)}px`,
                top: `${cursor.Y - (svgH / 2)}px`,
                width: `${svgW}px`,
                height: `${svgH}px`,
                pointerEvents: "none",
                opacity: 0.65,
                zIndex: 32,
            }]];
            const children_10 = [(props_8 = [["style", {
                width: `${svgW}px`,
                height: `${svgH}px`,
            }]], (children_8 = [(props_6 = [["style", {
                transform: `scale(${zoom})`,
            }]], (children_6 = [(props_4 = [["style", {
                transform: `translate(${40}px, ${40}px)`,
            }]], react_1.createElement("g", keyValueList(props_4, 1), ...patternInput_1[0]))], react_1.createElement("g", keyValueList(props_6, 1), ...children_6)))], react_1.createElement("svg", keyValueList(props_8, 1), ...children_8)))];
            return react_1.createElement("div", keyValueList(props_10, 1), ...children_10);
        }
    }
}

export function compareModelsApprox(m1, m2) {
    return equals(reduceApprox(m1), reduceApprox(m2));
}

export function viewCatalogue(model, dispatch) {
    let arg_3, arg_5, arg_7, arg_9, arg_11, arg_13, arg_15, matchValue_2, matchValue_3, matchValue_4;
    const dispatchAsFunc = (func) => {
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [uncurry2(func), dispatch]));
    };
    const muxTipMessage = (numBusses) => concat("Selects the one of its ", numBusses, " input busses numbered by the value of the select input \r\n                                to be the output. Adjusts bus width to match");
    const deMuxTipMessage = (numBits) => concat("The output numbered by the binary value \r\n        of the ", numBits, " sel inputs is equal to Data, the others are 0");
    const matchValue_7 = model.OpenLibrary;
    if (matchValue_7 == null) {
        const model_1 = model;
        const styles = (model_1.Sheet.Action.tag === 13) ? singleton(new CSSProp(/* Cursor */ 123, ["grabbing"])) : empty_1();
        const ghostMemory = new Memory1(InitMemData.FromData, 4, 8, empty({
            Compare: (x, y) => (compare_1(x, y) | 0),
        }), undefined);
        const searchTerm = model_1.CatalogueSearch.trim().toLocaleLowerCase();
        const searching = searchTerm !== "";
        const keep = (name, tip) => {
            if (!searching ? true : (name.toLocaleLowerCase().indexOf(searchTerm) >= 0)) {
                return true;
            }
            else {
                return tip.toLocaleLowerCase().indexOf(searchTerm) >= 0;
            }
        };
        const catTip1 = (name_1, ghost, func_1, tip_1) => {
            let props;
            const matchValue_1 = keep(name_1, tip_1);
            if (matchValue_1) {
                const react = placementItem(styles, () => (new DragGhost(/* GhostSymbol */ 0, [ghost, false])), name_1, () => {
                    func_1();
                }, model_1, dispatch);
                return singleton((props = [new HTMLAttr(/* ClassName */ 64, [concat("tooltip", " ", "has-tooltip-multiline")]), dataTooltip(tip_1), ["style", keyValueList(styles, 1)]], react_1.createElement("div", keyValueList(props, 1), react)));
            }
            else {
                return empty_1();
            }
        };
        const group = (title, items) => makeMenuGroupOpen(searching, title, concat_1(items));
        const groupWithTip = (title_1, tip_2, items_1) => makeMenuGroupWithTipOpen(searching, styles, title_1, tip_2, items_1);
        let searchBox;
        const props_2 = [["style", {
            padding: "0 6px 6px 6px",
        }]];
        const children_2 = [input_12(ofArray([new Option_1(/* Type */ 1, [IInputType.Text$]), new Option_1(/* Placeholder */ 12, ["Search components"]), new Option_1(/* Value */ 8, [model_1.CatalogueSearch]), new Option_1(/* Size */ 0, [Size_ISize.IsSmall]), new Option_1(/* OnChange */ 13, [(ev) => {
            const text = getTextEventValue(ev);
            dispatch(new Msg(/* UpdateModel */ 41, [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, catalogueSearch_)(text)]));
        }])]))];
        searchBox = react_1.createElement("div", keyValueList(props_2, 1), ...children_2);
        let noMatches;
        const props_4 = [["style", {
            padding: "10px",
            color: "grey",
        }]];
        const children_4 = [concat("No component matches \'", model_1.CatalogueSearch.trim(), "\'.")];
        noMatches = react_1.createElement("div", keyValueList(props_4, 1), ...children_4);
        const sections = ofArray([(arg_3 = ofArray([catTip1("Input", new ComponentType(/* Input1 */ 0, [1, undefined]), () => {
            dispatchAsFunc((model_2) => ((dispatch_1) => {
                createInputPopup("input", (tupledArg) => (new ComponentType(/* Input1 */ 0, [tupledArg[0], tupledArg[1]])), model_2, dispatch_1);
            }));
        }, "Input connection to current sheet: one or more bits"), catTip1("Output", new ComponentType(/* Output */ 1, [1]), () => {
            dispatchAsFunc((model_3) => ((dispatch_2) => {
                createIOPopup(true, "output", (BusWidth_1) => (new ComponentType(/* Output */ 1, [BusWidth_1])), model_3, dispatch_2);
            }));
        }, "Output connection from current sheet: one or more bits"), catTip1("Viewer", new ComponentType(/* Viewer */ 2, [1]), () => {
            dispatchAsFunc((model_4) => ((dispatch_3) => {
                createIOPopup(true, "viewer", (BusWidth_2) => (new ComponentType(/* Viewer */ 2, [BusWidth_2])), model_4, dispatch_3);
            }));
        }, "Viewer to expose value in step simulation: works in subsheets. Can also be used to terminate an unused output."), catTip1("Constant", new ComponentType(/* Constant1 */ 7, [1, fromZero(), "0"]), () => {
            dispatchAsFunc((model_5) => ((dispatch_4) => {
                createConstantPopup(model_5, dispatch_4);
            }));
        }, "Define a one or more bit constant value of specified width, e.g. 0 or 1, to drive an input. Values can be written in hex, decimal, or binary."), catTip1("Net Label", ComponentType.IOLabel, () => {
            dispatchAsFunc((model_6) => ((dispatch_5) => {
                createNetLabelPopup(model_6, dispatch_5);
            }));
        }, "Every net label with the same name is one net, connected within a sheet without wires: use them for long connections and high fan-out. Each net must have exactly one driving input. A net label can also be used to terminate an unused output"), catTip1("Not Connected", ComponentType.NotConnected, () => {
            dispatchAsFunc((model_7) => ((dispatch_6) => {
                createComponent(ComponentType.NotConnected, "", undefined, model_7, dispatch_6);
            }));
        }, "Not connected component to terminate unused output.")]), group("Input / Output", arg_3)), (arg_5 = ofArray([catTip1("MergeWires", ComponentType.MergeWires, () => {
            dispatchAsFunc((model_8) => ((dispatch_7) => {
                createComponent(ComponentType.MergeWires, "", undefined, model_8, dispatch_7);
            }));
        }, "Use Mergewires when you want to join the bits of a two busses to make a wider bus. Default has LS bits connected to top arm. Use Edit -> Flip Vertically after placing component to change this."), catTip1("MergeN", new ComponentType(/* MergeN */ 29, [2]), () => {
            dispatchAsFunc((model_9) => ((dispatch_8) => {
                createMergeNPopup(model_9, dispatch_8);
            }));
        }, `Use MergeN when you want to join the bits of between 2 and ${Constants_maxSplitMergeBranches} busses to make a wider bus.`), catTip1("SplitWire", new ComponentType(/* SplitWire */ 28, [1]), () => {
            dispatchAsFunc((model_10) => ((dispatch_9) => {
                createSplitWirePopup(model_10, dispatch_9);
            }));
        }, "Use Splitwire when you want to split the bits of a bus into two sets. Default has LS bits connected to top arm. Use Edit -> Flip Vertically after placing component to change this."), catTip1("SplitN", new ComponentType(/* SplitN */ 30, [2, ofArray([1, 1]), ofArray([0, 1])]), () => {
            dispatchAsFunc((model_11) => ((dispatch_10) => {
                createSplitNPopup(model_11, dispatch_10);
            }));
        }, `Use SplitN when you want to split between 2 and ${Constants_maxSplitMergeBranches} separate fields from a bus.`), catTip1("Bus Select", new ComponentType(/* BusSelection */ 6, [1, 0]), () => {
            dispatchAsFunc((model_12) => ((dispatch_11) => {
                createBusSelectPopup(model_12, dispatch_11);
            }));
        }, "Bus Select output connects to one or more selected bits of its input"), catTip1("Bus Compare", new ComponentType(/* BusCompare1 */ 5, [1, fromZero(), "0"]), () => {
            dispatchAsFunc((model_13) => ((dispatch_12) => {
                createBusComparePopup(model_13, dispatch_12);
            }));
        }, "Bus compare outputs 1 if the input bus matches a constant value as written in decimal, hex, or binary."), catTip1("N bits spreader", new ComponentType(/* NbitSpreader */ 25, [1]), () => {
            dispatchAsFunc((model_14) => ((dispatch_13) => {
                createNbitSpreaderPopup(model_14, dispatch_13);
            }));
        }, "Replicates a 1 bit input onto all N bits of an output bus")]), group("Buses", arg_5)), (arg_7 = ofArray([catTip1("Not", ComponentType.Not, () => {
            dispatchAsFunc((model_15) => ((dispatch_14) => {
                createCompStdLabel(ComponentType.Not, undefined, model_15, dispatch_14);
            }));
        }, "Invertor: output is negation of input"), catTip1("And", new ComponentType(/* GateN */ 10, ["and", 2]), () => {
            dispatchAsFunc((model_16) => ((dispatch_15) => {
                createCompStdLabel(new ComponentType(/* GateN */ 10, ["and", 2]), undefined, model_16, dispatch_15);
            }));
        }, "Output is 1 if all the inputs are 1. Use Properties to add more inputs"), catTip1("Or", new ComponentType(/* GateN */ 10, ["or", 2]), () => {
            dispatchAsFunc((model_17) => ((dispatch_16) => {
                createCompStdLabel(new ComponentType(/* GateN */ 10, ["or", 2]), undefined, model_17, dispatch_16);
            }));
        }, "Output is 1 if any of the inputs are 1. Use Properties to add more inputs"), catTip1("Xor", new ComponentType(/* GateN */ 10, ["xor", 2]), () => {
            dispatchAsFunc((model_18) => ((dispatch_17) => {
                createCompStdLabel(new ComponentType(/* GateN */ 10, ["xor", 2]), undefined, model_18, dispatch_17);
            }));
        }, "Output is 1 if an odd number of inputs are 1. Use Properties to add more inputs"), catTip1("Nand", new ComponentType(/* GateN */ 10, ["nand", 2]), () => {
            dispatchAsFunc((model_19) => ((dispatch_18) => {
                createCompStdLabel(new ComponentType(/* GateN */ 10, ["nand", 2]), undefined, model_19, dispatch_18);
            }));
        }, "Output is 0 if all the inputs are 1. Use Properties to add more inputs"), catTip1("Nor", new ComponentType(/* GateN */ 10, ["nor", 2]), () => {
            dispatchAsFunc((model_20) => ((dispatch_19) => {
                createCompStdLabel(new ComponentType(/* GateN */ 10, ["nor", 2]), undefined, model_20, dispatch_19);
            }));
        }, "Output is 0 if any of the inputs are 1. Use Properties to add more inputs"), catTip1("Xnor", new ComponentType(/* GateN */ 10, ["xnor", 2]), () => {
            dispatchAsFunc((model_21) => ((dispatch_20) => {
                createCompStdLabel(new ComponentType(/* GateN */ 10, ["xnor", 2]), undefined, model_21, dispatch_20);
            }));
        }, "Output is 1 if an even number of inputs are 1. Use Properties to add more inputs"), catTip1("N bits NOT", new ComponentType(/* NbitsNot */ 23, [1]), () => {
            dispatchAsFunc((model_22) => ((dispatch_21) => {
                createArithmeticPopup(new ComponentType(/* NbitsNot */ 23, [1]), model_22, dispatch_21);
            }));
        }, "N bit NOT gates: one per bit of the input and output busses"), catTip1("N bits AND", new ComponentType(/* NbitsAnd */ 22, [1]), () => {
            dispatchAsFunc((model_23) => ((dispatch_22) => {
                createArithmeticPopup(new ComponentType(/* NbitsAnd */ 22, [1]), model_23, dispatch_22);
            }));
        }, "N bit AND gates: one per bit of the input and output busses"), catTip1("N bits OR", new ComponentType(/* NbitsOr */ 24, [1]), () => {
            dispatchAsFunc((model_24) => ((dispatch_23) => {
                createArithmeticPopup(new ComponentType(/* NbitsOr */ 24, [1]), model_24, dispatch_23);
            }));
        }, "N bit OR gates: one per bit of the input and output busses"), catTip1("N bits XOR", new ComponentType(/* NbitsXor */ 21, [1, undefined]), () => {
            dispatchAsFunc((model_25) => ((dispatch_24) => {
                createArithmeticPopup(new ComponentType(/* NbitsXor */ 21, [1, undefined]), model_25, dispatch_24);
            }));
        }, "N bit XOR gates - use to make subtractor or comparator")]), group("Gates", arg_7)), (arg_9 = ofArray([catTip1("2-Mux", ComponentType.Mux2, () => {
            dispatchAsFunc((model_26) => ((dispatch_25) => {
                createCompStdLabel(ComponentType.Mux2, undefined, model_26, dispatch_25);
            }));
        }, muxTipMessage("two")), catTip1("4-Mux", ComponentType.Mux4, () => {
            dispatchAsFunc((model_27) => ((dispatch_26) => {
                createCompStdLabel(ComponentType.Mux4, undefined, model_27, dispatch_26);
            }));
        }, muxTipMessage("four")), catTip1("8-Mux", ComponentType.Mux8, () => {
            dispatchAsFunc((model_28) => ((dispatch_27) => {
                createCompStdLabel(ComponentType.Mux8, undefined, model_28, dispatch_27);
            }));
        }, muxTipMessage("eight")), catTip1("2-Demux", ComponentType.Demux2, () => {
            dispatchAsFunc((model_29) => ((dispatch_28) => {
                createCompStdLabel(ComponentType.Demux2, undefined, model_29, dispatch_28);
            }));
        }, deMuxTipMessage("two")), catTip1("4-Demux", ComponentType.Demux4, () => {
            dispatchAsFunc((model_30) => ((dispatch_29) => {
                createCompStdLabel(ComponentType.Demux4, undefined, model_30, dispatch_29);
            }));
        }, deMuxTipMessage("four")), catTip1("8-Demux", ComponentType.Demux8, () => {
            dispatchAsFunc((model_31) => ((dispatch_30) => {
                createCompStdLabel(ComponentType.Demux8, undefined, model_31, dispatch_30);
            }));
        }, deMuxTipMessage("eight"))]), group("Mux / Demux", arg_9)), (arg_11 = ofArray([catTip1("N bits adder", new ComponentType(/* NbitsAdder */ 17, [1]), () => {
            dispatchAsFunc((model_32) => ((dispatch_31) => {
                createArithmeticPopup(new ComponentType(/* NbitsAdder */ 17, [1]), model_32, dispatch_31);
            }));
        }, "N bit Binary adder with carry in to bit 0 and carry out from bit N-1"), catTip1("N bits shift", new ComponentType(/* Shift */ 46, [1, 1, ShiftComponentType.LSL]), () => {
            dispatchAsFunc((model_33) => ((dispatch_32) => {
                createShiftPopup(model_33, dispatch_32);
            }));
        }, "N bit shifter: shifts the input by the number of positions on the SHIFT input. The kind of shift - logical left (LSL), logical right (LSR) or arithmetic right (ASR) - is chosen when the component is created")]), group("Arithmetic", arg_11)), (arg_13 = ofArray([catTip1("D-flip-flop", ComponentType.DFF, () => {
            dispatchAsFunc((model_34) => ((dispatch_33) => {
                createCompStdLabel(ComponentType.DFF, undefined, model_34, dispatch_33);
            }));
        }, "D flip-flop - note that clock is assumed always connected to a global clock, so ripple counters cannot be implemented in Issie"), catTip1("D-flip-flop with enable", ComponentType.DFFE, () => {
            dispatchAsFunc((model_35) => ((dispatch_34) => {
                createCompStdLabel(ComponentType.DFFE, undefined, model_35, dispatch_34);
            }));
        }, "D flip-flop: output will remain unchanged when En is 0"), catTip1("Register", new ComponentType(/* Register */ 33, [1]), () => {
            dispatchAsFunc((model_36) => ((dispatch_35) => {
                createRegisterPopup(new ComponentType(/* Register */ 33, [0]), model_36, dispatch_35);
            }));
        }, "N D flip-flops with inputs and outputs combined into single N bit busses"), catTip1("Register with enable", new ComponentType(/* RegisterE */ 34, [1]), () => {
            dispatchAsFunc((model_37) => ((dispatch_36) => {
                createRegisterPopup(new ComponentType(/* RegisterE */ 34, [0]), model_37, dispatch_36);
            }));
        }, "As register but outputs stay the same if En is 0"), catTip1("Counter", new ComponentType(/* Counter */ 35, [1]), () => {
            dispatchAsFunc((model_38) => ((dispatch_37) => {
                createRegisterPopup(new ComponentType(/* Counter */ 35, [0]), model_38, dispatch_37);
            }));
        }, "N-bits counter with customisable enable and load inputs")]), group("Flip Flops and Registers", arg_13)), (arg_15 = ofArray([catTip1("ROM (asynchronous)", new ComponentType(/* AsyncROM1 */ 39, [ghostMemory]), () => {
            dispatchAsFunc((model_39) => ((dispatch_38) => {
                createMemoryPopup((Item) => (new ComponentType(/* AsyncROM1 */ 39, [Item])), model_39, dispatch_38);
            }));
        }, "This is combinational: the output is available in the same clock cycle that the address is presented"), catTip1("ROM (synchronous)", new ComponentType(/* ROM1 */ 40, [ghostMemory]), () => {
            dispatchAsFunc((model_40) => ((dispatch_39) => {
                createMemoryPopup((Item_1) => (new ComponentType(/* ROM1 */ 40, [Item_1])), model_40, dispatch_39);
            }));
        }, "A ROM whose output contains the addressed data in the clock cycle after the address is presented"), catTip1("RAM (synchronous)", new ComponentType(/* RAM1 */ 41, [ghostMemory]), () => {
            dispatchAsFunc((model_41) => ((dispatch_40) => {
                createMemoryPopup((Item_2) => (new ComponentType(/* RAM1 */ 41, [Item_2])), model_41, dispatch_40);
            }));
        }, "A RAM whose output contains the addressed data in the clock cycle after the address is presented"), catTip1("RAM (async read)", new ComponentType(/* AsyncRAM1 */ 42, [ghostMemory]), () => {
            dispatchAsFunc((model_42) => ((dispatch_41) => {
                createMemoryPopup((Item_3) => (new ComponentType(/* AsyncRAM1 */ 42, [Item_3])), model_42, dispatch_41);
            }));
        }, "A RAM whose output contains the addressed data in the same clock cycle as address is presented")]), group("Memories", arg_15)), groupWithTip("This project", "Every design sheet is available for use in other sheets as a custom component: it can be added any number of times, each instance replicating the sheet logic", makeCustomList(keep, styles, model_1, dispatch)), groupWithTip("Array components", (matchValue_2 = openSheetArrayInfo(model_1), (matchValue_2 != null) ? "This sheet defines an array component: it defines multiple copies of what is drawn on it, one per value of its loop variable. Components here define how the copies join to each other and to the outside. An ordinary Input goes to every copy, and an ordinary Output gives one port per copy." : "Make sheets whose hardware is an array of copies of what is drawn."), concat_1([searching ? empty_1() : singleton(menuItem(styles, "New array component", (_arg_41) => {
            dispatchAsFunc((model_43) => ((_arg_42) => {
                newArrayComponentPopup(model_43, dispatch);
            }));
        })), (matchValue_3 = openSheetArrayInfo(model_1), (matchValue_3 != null) ? concat_1([catTip1("Bus out", new ComponentType(/* BusOut */ 50, [1]), () => {
            dispatchAsFunc((model_44) => ((dispatch_42) => {
                createIOPopup(true, "bus output", (BusWidth_3) => (new ComponentType(/* BusOut */ 50, [BusWidth_3])), model_44, dispatch_42);
            }));
        }, "Takes one value from each copy and joins them into a single bus, copy 0 in the least significant bits. The sheet gets one output of width (number of copies) x (this width)."), catTip1("Array out", new ComponentType(/* MuxOut */ 51, [1]), () => {
            dispatchAsFunc((model_45) => ((dispatch_43) => {
                createIOPopup(true, "array output", (BusWidth_4) => (new ComponentType(/* MuxOut */ 51, [BusWidth_4])), model_45, dispatch_43);
            }));
        }, "Takes one value from each copy, to be selected between by the multiplexers declared in this sheet\'s array settings. It adds no port of its own: each multiplexer adds a select input and an output."), catTip1("Join out", new ComponentType(/* JoinOut */ 52, [1, 0]), () => {
            dispatchAsFunc((model_46) => ((dispatch_44) => {
                createJoinPopup("join out", (tupledArg_1) => (new ComponentType(/* JoinOut */ 52, [tupledArg_1[0], tupledArg_1[1]])), model_46, dispatch_44);
            }));
        }, "Sends this copy\'s value to the copy whose Join in has the same name and the same channel number. Where no copy takes it - at the end of a chain - it becomes an output of this sheet."), catTip1("Join in", new ComponentType(/* JoinIn */ 53, [1, 0]), () => {
            dispatchAsFunc((model_47) => ((dispatch_45) => {
                createJoinPopup("join in", (tupledArg_2) => (new ComponentType(/* JoinIn */ 53, [tupledArg_2[0], tupledArg_2[1]])), model_47, dispatch_45);
            }));
        }, "Takes this copy\'s value from the copy whose Join out has the same name and the same channel number. Where no copy sends it - at the start of a chain - it becomes an input of this sheet.")]) : empty_1())])), groupWithTip("Verilog", "Write combinational or synchronous logic in Verilog and use it as a Custom Component.\r\n                         To edit/delete a verilog component add it in a sheet and click on \'properties\'", append(searching ? empty_1() : singleton(menuItem(styles, "New Verilog Component", (_arg_47) => {
            dispatchAsFunc((model_48) => ((_arg_48) => {
                createVerilogPopup(model_48, true, undefined, undefined, CodeEditorOpen.NewVerilogFile, dispatch);
            }));
        })), makeVerilogList(keep, styles, model_1, dispatch))), groupWithTip("Library", "Ready-made parameterised components. Choosing one adds its sheet to this project and asks for the values its parameters should take.", map((lib_1) => menuItemWithId(libraryRowId(lib_1.Name), styles, lib_1.Name, (_arg_49) => {
            const opened = openLibrary(lib_1);
            dispatch(new Msg(/* UpdateModel */ 41, [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, openLibrary_)(opened)]));
        }), filter((lib) => keep(lib.Name, ""), model_1.ComponentLibraries)))]);
        const props_6 = [["style", keyValueList(styles, 1)]];
        const children_6 = [searchBox, menu(singleton(new Common_GenericOption(/* Props */ 1, [ofArray([new HTMLAttr(/* Class */ 65, ["py-1"]), ["style", keyValueList(append(ofArray([new CSSProp(/* Height */ 189, ["calc(100vh - 240px)"]), new CSSProp(/* OverflowY */ 272, ["auto"])]), styles), 1)]])])), (matchValue_4 = filter((s_1) => !Operators_IsNull(s_1), sections), isEmpty_1(matchValue_4) ? singleton(noMatches) : matchValue_4))];
        return react_1.createElement("div", keyValueList(props_6, 1), ...children_6);
    }
    else {
        const library = matchValue_7;
        const model_49 = model;
        const styles_1 = (model_49.Sheet.Action.tag === 13) ? singleton(new CSSProp(/* Cursor */ 123, ["grabbing"])) : empty_1();
        return menu(singleton(new Common_GenericOption(/* Props */ 1, [ofArray([new HTMLAttr(/* Class */ 65, ["py-1"]), ["style", keyValueList(append(ofArray([new CSSProp(/* Height */ 189, ["calc(100vh - 200px)"]), new CSSProp(/* OverflowY */ 272, ["auto"])]), styles_1), 1)]])])), toList(delay(() => {
            let props_14, children_14, children_10, children_12;
            return append_1(singleton_1((props_14 = [["style", {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "6px",
            }]], (children_14 = [(children_10 = [concat(library.Name, " library")], react_1.createElement("b", {}, ...children_10)), (children_12 = toList(delay(() => append_1(libraryIsEditable(new ComponentLibrary(library.Name, library.Path)) ? singleton_1(button(ofArray([new Option_3(/* Size */ 1, [Size_ISize.IsSmall]), new Option_3(/* Props */ 17, [singleton(new HTMLAttr(/* Title */ 158, ["Open this library as a project, so that its components can be changed where they are. Each component is a sheet, and saving one writes it back into the library."]))]), new Option_3(/* OnClick */ 18, [(_arg_50) => {
                dispatch(new Msg(/* UpdateModel */ 41, [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, openLibrary_)(undefined)]));
                dispatch(new Msg(/* FileCommand */ 111, [new FileCommandType(/* FileOpenLibrary */ 7, [new ComponentLibrary(library.Name, library.Path)]), dispatch]));
            }])]), singleton("Edit"))) : empty_2(), delay(() => singleton_1(button(ofArray([new Option_3(/* Size */ 1, [Size_ISize.IsSmall]), new Option_3(/* Props */ 17, [singleton(["style", {
                marginLeft: "4px",
            }])]), new Option_3(/* OnClick */ 18, [(_arg_51) => {
                dispatch(new Msg(/* UpdateModel */ 41, [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, openLibrary_)(undefined)]));
            }])]), singleton("Back"))))))), react_1.createElement("div", {}, ...children_12))], react_1.createElement("div", keyValueList(props_14, 1), ...children_14)))), delay(() => {
                let matchValue_6, props_18, children_18;
                return append_1((matchValue_6 = library.Problems, isEmpty_1(matchValue_6) ? singleton_1(defaultOf()) : singleton_1((props_18 = [["style", {
                    color: "red",
                    fontSize: "11px",
                    marginBottom: "6px",
                }]], (children_18 = map((problem) => react_1.createElement("div", {}, problem), matchValue_6), react_1.createElement("div", keyValueList(props_18, 1), ...children_18))))), delay(() => map((tupledArg_3) => makeMenuGroup(tupledArg_3[0], map((listing) => {
                    const props_8 = [new HTMLAttr(/* ClassName */ 64, [concat("tooltip", " ", "has-tooltip-multiline")]), dataTooltip(listing.Header.Description), ["style", keyValueList(styles_1, 1)]];
                    const children_8 = [placementItem(styles_1, () => libraryGhost(library, listing, model_49), listing.Header.Name, () => {
                        dispatchAsFunc((model_50) => ((dispatch_46) => {
                            startPlacingLibraryComponent(library, listing, model_50, dispatch_46);
                        }));
                    }, model_49, dispatch)];
                    return react_1.createElement("div", keyValueList(props_8, 1), ...children_8);
                }, tupledArg_3[1])), sortBy((tuple) => tuple[0], List_groupBy((listing_1) => listing_1.Header.Section, library.Components, {
                    Equals: (x_1, y_1) => (x_1 === y_1),
                    GetHashCode: (x_1) => (stringHash(x_1) | 0),
                }), {
                    Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
                }))));
            }));
        })));
    }
}

